import React, { useState } from "react";
import { Grid, Container } from "@mui/material";
import Header from "./ClientSurveyHeader";
import { Link } from "react-router-dom";
import "../assets/css/ClientSurvey.css";
import axios from "axios";
import { useIntl } from "react-intl";

import { getApiBase } from "../helpers/apiBase";
export default function ClientServeyMain(props) {
  const intl = useIntl();
  const [isShowStep0Block, setisShowStep0Block] = useState(true);
  const [isShowStep1Block, setisShowStep1Block] = useState(false);
  const [isShowStep2Block, setisShowStep2Block] = useState(false);
  const [isShowStep3Block, setisShowStep3Block] = useState(false);
  const [isShowStep4Block, setisShowStep4Block] = useState(false);
  const [isShowStep5Block, setisShowStep5Block] = useState(false);
  const [isShowStep6Block, setisShowStep6Block] = useState(false);
  const [isShowStep7Block, setisShowStep7Block] = useState(false);
  const [isShowThakyouBlock, setisShowThakyouBlock] = useState(false);

  const goToStepOne = (e) => {
    setisShowStep0Block(false);
    setisShowStep1Block(true);
  };

  const goToStep2Block = (e) => {
    setisShowStep1Block(false);
    setisShowStep2Block(true);
  };
  const goToStep3Block = (e) => {
    setisShowStep2Block(false);
    setisShowStep3Block(true);
  };
  const goToStep4Block = (e) => {
    setisShowStep3Block(false);
    setisShowStep4Block(true);
  };

  const goToStep5Block = (e) => {
    setisShowStep4Block(false);
    setisShowStep5Block(true);
  };
  const goToStep6Block = (e) => {
    setisShowStep5Block(false);
    setisShowStep6Block(true);
  };
  const goToStep7Block = (e) => {
    setisShowStep6Block(false);
    setisShowStep7Block(true);
  };
  const [contact_name, set_contact_name] = useState("");
  const [contact_email, set_contact_email] = useState("");
  const [contact_phone, set_contact_phone] = useState("");
  const [contact_feedback, set_contact_feedback] = useState("");
  const [emailError, setemailError] = useState("");
  const [phoneError, setphoneError] = useState("");

  const gotoPreviousStep = (previosStep) => {
    if (previosStep === 1) {
      setisShowStep1Block(true);
      setisShowStep2Block(false);
    } else if (previosStep === 2) {
      setisShowStep2Block(true);
      setisShowStep3Block(false);
    } else if (previosStep === 3) {
      setisShowStep3Block(true);
      setisShowStep4Block(false);
    } else if (previosStep === 4) {
      setisShowStep4Block(true);
      setisShowStep5Block(false);
    } else if (previosStep === 5) {
      setisShowStep5Block(true);
      setisShowStep6Block(false);
    } else if (previosStep === 6) {
      setisShowStep6Block(true);
      setisShowStep7Block(false);
    }
  };

  const [q1rating, setq1rating] = useState("");
  const [q1notes, setq1notes] = useState("");

  const [q2rating, setq2rating] = useState("");
  const [q2notes, setq2notes] = useState("");

  const [q3rating, setq3rating] = useState("");
  const [q3notes, setq3notes] = useState("");

  const [q4SelectedMatters, setq4SelectedMatters] = useState([]);
  const [q4notes, setq4notes] = useState("");

  const [q5SelectedMatters, setq5SelectedMatters] = useState([]);
  const [q5notes, setq5notes] = useState("");

  const [q6SelectedMatters, setq6SelectedMatters] = useState([]);

  const goToTankyou = (e) => {
    e.preventDefault();
    setemailError("");
    setphoneError("");
    var pattern = new RegExp(
      /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
    );
    let isValidate = 1;

    if (contact_email !== "" && !pattern.test(contact_email)) {
      setemailError(intl.formatMessage({ id: "enter-valid-email" }));
      isValidate = 0;
    }

    if (contact_phone !== "" && contact_phone.length !== 10) {
      setphoneError(intl.formatMessage({ id: "phone-number-should-be-10-digit" }));
      isValidate = 0;
    }

    if (isValidate === 1) {
      let form_data = new FormData();
      form_data.append("company_id", localStorage.getItem("company_id"));
      form_data.append("answer_1", q1rating);
      form_data.append("answer_2", q1notes);
      form_data.append("answer_3", q2rating);
      form_data.append("answer_4", q2notes);
      form_data.append("answer_5", q3rating);
      form_data.append("answer_6", q3notes);
      form_data.append("answer_7", q4SelectedMatters.join(","));
      form_data.append("answer_8", q4notes);
      form_data.append("answer_9", q5SelectedMatters.join(","));
      form_data.append("answer_10", q5notes);
      form_data.append("answer_11", q6SelectedMatters.join(","));
      form_data.append("answer_12", contact_name);
      form_data.append("answer_13", contact_email);
      form_data.append("answer_14", contact_phone);
      form_data.append("answer_15", contact_feedback);

      const baseUrl = getApiBase();
      let url = "clientSurvey/addClientSurvey";

      axios
        .post(`${baseUrl}/${url}`, form_data, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          if (res.data) {
            setisShowStep7Block(false);
            setisShowThakyouBlock(true);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const handleQ4MattersCheckbox = (e) => {
    if (e.target.checked) {
      setq4SelectedMatters([...q4SelectedMatters, e.target.value]);
    } else {
      setq4SelectedMatters(
        q4SelectedMatters.filter((people) => people !== e.target.value)
      );
    }
  };

  const handleQ5MattersCheckbox = (e) => {
    if (e.target.checked) {
      setq5SelectedMatters([...q5SelectedMatters, e.target.value]);
    } else {
      setq5SelectedMatters(
        q5SelectedMatters.filter((people) => people !== e.target.value)
      );
    }
  };

  const [countOrder, setcountOrder] = useState([]);
  const handleQ6MattersCheckbox = (e, orderNum) => {
    if (e.target.checked) {
      setq6SelectedMatters([...q6SelectedMatters, e.target.value]);

      setcountOrder([...countOrder, orderNum]);
    } else {
      setq6SelectedMatters(
        q6SelectedMatters.filter((people) => people !== e.target.value)
      );

      setcountOrder(countOrder.filter((orderVal) => orderVal !== orderNum));
    }
  };

  let q6Order1Index = countOrder.indexOf(1);
  let q6Order2Index = countOrder.indexOf(2);
  let q6Order3Index = countOrder.indexOf(3);
  let q6Order4Index = countOrder.indexOf(4);
  let q6Order5Index = countOrder.indexOf(5);
  let q6Order6Index = countOrder.indexOf(6);
  let q6Order1 = q6Order1Index + 1;
  let q6Order2 = q6Order2Index + 1;
  let q6Order3 = q6Order3Index + 1;
  let q6Order4 = q6Order4Index + 1;
  let q6Order5 = q6Order5Index + 1;
  let q6Order6 = q6Order6Index + 1;

  return (
    <React.Fragment>
      <div className="client-servey">
        {/* header */}
        <Header />
        {/* header */}
        {/* main body */}
        {isShowStep0Block === true ? (
          <Container style={{ marginTop: "50px" }}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={2} sm={12} align="center"></Grid>

              <Grid item xs={12} md={8} sm={12} align="center">
                <div className="enterDiv">
                  <div>
                    <h3>
                      {intl.formatMessage({
                        id: "client-survey-main-thanks-note",
                      })}
                    </h3>
                  </div>
                  <div style={{ paddingTop: "3rem" }}>
                    <button
                      className="btn btn-sm client-survey-btn"
                      onClick={(e) => goToStepOne(e)}
                    >
                      {intl.formatMessage({
                        id: "enter",
                      })}
                    </button>
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} md={2} sm={12} align="center"></Grid>
            </Grid>
          </Container>
        ) : isShowStep1Block === true ? (
          <div>
            <section className="w-full py-12 bg-white">
              <div className="max-w-4xl px-4 mx-auto sm:px-6 lg:px-0 client-servey-less-padding">
                <h1 className="max-w-2xl mx-auto text-2xl font-semibold text-center sm:text-3xl lg:text-4xl client-servey-question-font-size">
                  {intl.formatMessage({
                    id: "client-survey-how-likely-recommend",
                  })}
                </h1>
                <div className="relative z-0 flex flex-wrap items-center justify-center my-8 gap-x-4 gap-y-4">
                  <div className="relative">
                    {/* <label className="sr-only">
                                 0
                            </label> */}
                    <div className="client-servey-custom-radio">
                      <input
                        type="radio"
                        id="ratingZero"
                        tabIndex={0}
                        name="q1rating"
                        value={0}
                        checked={q1rating === 0 ? true : false}
                        onChange={(e) => setq1rating(0)}
                      />
                      <label className="low" htmlFor="ratingZero">
                        0
                      </label>
                    </div>
                  </div>
                  <div className="relative">
                    {/* <label className="sr-only">
                            1
                            </label> */}
                    <div className="client-servey-custom-radio">
                      <input
                        type="radio"
                        id="ratingOne"
                        tabIndex={0}
                        name="q1rating"
                        value={1}
                        checked={q1rating === 1 ? true : false}
                        onChange={(e) => setq1rating(1)}
                      />
                      <label className="low" htmlFor="ratingOne">
                        1
                      </label>
                    </div>
                  </div>
                  <div className="relative">
                    {/* <label className="sr-only">
                            2
                            </label> */}
                    <div className="client-servey-custom-radio">
                      <input
                        type="radio"
                        id="ratingTwo"
                        tabIndex={0}
                        name="q1rating"
                        value={2}
                        checked={q1rating === 2 ? true : false}
                        onChange={(e) => setq1rating(2)}
                      />
                      <label className="low" htmlFor="ratingTwo">
                        2
                      </label>
                    </div>
                  </div>
                  <div className="relative">
                    {/* <label htmlFor="ratingThree" className="sr-only">
                            3
                            </label> */}
                    <div className="client-servey-custom-radio">
                      <input
                        type="radio"
                        id="ratingThree"
                        tabIndex={0}
                        name="q1rating"
                        value={3}
                        checked={q1rating === 3 ? true : false}
                        onChange={(e) => setq1rating(3)}
                      />
                      <label className="low" htmlFor="ratingThree">
                        3
                      </label>
                    </div>
                  </div>
                  <div className="relative">
                    {/* <label htmlFor="ratingFour" className="sr-only">
                                4
                            </label> */}
                    <div className="client-servey-custom-radio">
                      <input
                        type="radio"
                        id="ratingFour"
                        tabIndex={0}
                        name="q1rating"
                        value={4}
                        checked={q1rating === 4 ? true : false}
                        onChange={(e) => setq1rating(4)}
                      />
                      <label className="low" htmlFor="ratingFour">
                        4
                      </label>
                    </div>
                  </div>
                  <div className="relative">
                    {/* <label htmlFor="ratingFive" className="sr-only">
                            5
                            </label> */}
                    <div className="client-servey-custom-radio">
                      <input
                        type="radio"
                        id="ratingFive"
                        tabIndex={0}
                        name="q1rating"
                        value={5}
                        checked={q1rating === 5 ? true : false}
                        onChange={(e) => setq1rating(5)}
                      />
                      <label className="low" htmlFor="ratingFive">
                        5
                      </label>
                    </div>
                  </div>
                  <div className="relative">
                    {/* <label htmlFor="ratingSix" className="sr-only">
                            6
                            </label> */}
                    <div className="client-servey-custom-radio">
                      <input
                        type="radio"
                        id="ratingSix"
                        tabIndex={0}
                        name="q1rating"
                        value={6}
                        checked={q1rating === 6 ? true : false}
                        onChange={(e) => setq1rating(6)}
                      />
                      <label className="low" htmlFor="ratingSix">
                        6
                      </label>
                    </div>
                  </div>
                  <div className="relative">
                    {/* <label htmlFor="ratingSeven" className="sr-only">
                            7
                            </label> */}
                    <div className="client-servey-custom-radio">
                      <input
                        type="radio"
                        id="ratingSeven"
                        tabIndex={0}
                        name="q1rating"
                        value={7}
                        checked={q1rating === 7 ? true : false}
                        onChange={(e) => setq1rating(7)}
                      />
                      <label className="medium" htmlFor="ratingSeven">
                        7
                      </label>
                    </div>
                  </div>
                  <div className="relative">
                    {/* <label htmlFor="ratingEight" className="sr-only">
                            8
                            </label> */}
                    <div className="client-servey-custom-radio">
                      <input
                        type="radio"
                        id="ratingEight"
                        tabIndex={0}
                        name="q1rating"
                        value={8}
                        checked={q1rating === 8 ? true : false}
                        onChange={(e) => setq1rating(8)}
                      />
                      <label className="medium" htmlFor="ratingEight">
                        8
                      </label>
                    </div>
                  </div>
                  <div className="relative">
                    {/* <label htmlFor="ratingNine" className="sr-only">
                            9
                            </label> */}
                    <div className="client-servey-custom-radio">
                      <input
                        type="radio"
                        id="ratingNine"
                        tabIndex={0}
                        name="q1rating"
                        value={9}
                        checked={q1rating === 9 ? true : false}
                        onChange={(e) => setq1rating(9)}
                      />
                      <label className="high" htmlFor="ratingNine">
                        9
                      </label>
                    </div>
                  </div>
                  <div className="relative">
                    {/* <label htmlFor="ratingTen" className="sr-only">
                            10
                            </label> */}
                    <div className="client-servey-custom-radio">
                      <input
                        type="radio"
                        id="ratingTen"
                        tabIndex={0}
                        name="q1rating"
                        value={10}
                        checked={q1rating === 10 ? true : false}
                        onChange={(e) => setq1rating(10)}
                      />
                      <label className="high" htmlFor="ratingTen">
                        10
                      </label>
                    </div>
                  </div>
                </div>
                <p
                  className="text-center text-gray-600"
                  style={{ fontSize: "16px" }}
                >
                  {intl.formatMessage({
                    id: "client-survey-how-likely-note",
                  })}
                </p>
                <div className="max-w-2xl mx-auto mt-12">
                  <label className="form-input-label">
                    {intl.formatMessage({
                      id: "client-survey-how-likely-recommend-question",
                    })}
                  </label>
                  <div className="mt-1">
                    <textarea
                      id="q1notes"
                      className="form-control client-servey-textarea form-control-client-servey"
                      rows={4}
                      value={q1notes}
                      onChange={(e) => setq1notes(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </section>
            <footer className="sticky inset-x-0 bottom-0 z-20 w-full py-6 mt-auto bg-white border-t border-gray-200">
              <div className="max-w-4xl px-4 mx-auto sm:px-6 lg:px-0 client-servey-less-padding">
                <div className="relative flex items-center justify-between">
                  <div />
                  <div className="absolute inset-0 py-2 -translate-x-1/2 left-half">
                    <nav
                      className="flex items-center justify-center"
                      aria-label="Progress"
                    >
                      <p className="text-sm font-medium">
                        {intl.formatMessage(
                          { id: "step-of" },
                          { step: 1, total: 7 }
                        )}
                      </p>
                      <ol className="items-center hidden ml-8 space-x-5 sm:flex">
                        <li>
                          <div
                            className="relative flex items-center justify-center"
                            aria-current="step"
                          >
                            <span
                              className="absolute flex w-5 h-5 p-px curntStepHighlight"
                              aria-hidden="true"
                            >
                              <span className="w-full h-full rounded-full bg-rose-200" />
                            </span>
                            <span
                              className="relative block w-2.5 h-2.5 bg-rose-600 rounded-full"
                              aria-hidden="true"
                            />
                            <span className="sr-only">
                              {intl.formatMessage({ id: "step" }, { step: 1 })}
                            </span>
                          </div>
                        </li>
                        <li>
                          <div className="block w-2.5 h-2.5 bg-gray-200 rounded-full hover:bg-gray-400">
                            <span className="sr-only">
                              {intl.formatMessage({ id: "step" }, { step: 2 })}
                            </span>
                          </div>
                        </li>
                        <li>
                          <div className="block w-2.5 h-2.5 bg-gray-200 rounded-full hover:bg-gray-400">
                            <span className="sr-only">
                              {intl.formatMessage({ id: "step" }, { step: 3 })}
                            </span>
                          </div>
                        </li>
                        <li>
                          <div className="block w-2.5 h-2.5 bg-gray-200 rounded-full hover:bg-gray-400">
                            <span className="sr-only">
                              {intl.formatMessage({ id: "step" }, { step: 4 })}
                            </span>
                          </div>
                        </li>
                        <li>
                          <div className="block w-2.5 h-2.5 bg-gray-200 rounded-full hover:bg-gray-400">
                            <span className="sr-only">
                              {intl.formatMessage({ id: "step" }, { step: 5 })}
                            </span>
                          </div>
                        </li>
                        <li>
                          <div className="block w-2.5 h-2.5 bg-gray-200 rounded-full hover:bg-gray-400">
                            <span className="sr-only">
                              {intl.formatMessage({ id: "step" }, { step: 6 })}
                            </span>
                          </div>
                        </li>
                        <li>
                          <div className="block w-2.5 h-2.5 bg-gray-200 rounded-full hover:bg-gray-400">
                            <span className="sr-only">
                              {intl.formatMessage({ id: "step" }, { step: 7 })}
                            </span>
                          </div>
                        </li>
                      </ol>
                    </nav>
                  </div>
                  <button
                    id="next_page_1"
                    onClick={(e) => goToStep2Block(e)}
                    className="btn btn-primary client-survey-btn client-survey-next-btn"
                  >
                    {intl.formatMessage({ id: "next" })}
                  </button>
                </div>
              </div>
            </footer>
          </div>
        ) : isShowStep2Block === true ? (
          <div>
            <section className="w-full py-12 bg-white">
              <div className="max-w-4xl px-4 mx-auto sm:px-6 lg:px-0 client-servey-less-padding">
                <h1 className="max-w-2xl mx-auto text-2xl font-semibold text-center sm:text-3xl lg:text-4xl client-servey-question-font-size">
                  {intl.formatMessage({
                    id: "client-survey-how-satisfied-with-service",
                  })}
                </h1>
                <div className="relative z-0 flex flex-wrap items-center justify-center my-8 gap-x-4 gap-y-4">
                  <div className="relative">
                    {/* <label className="sr-only">
                            1
                            </label> */}
                    <div className="client-servey-custom-radio">
                      <input
                        type="radio"
                        id="ratingOne"
                        tabIndex={0}
                        name="q2rating"
                        value={1}
                        checked={q2rating === 1 ? true : false}
                        onChange={(e) => setq2rating(1)}
                      />
                      <label className="low" htmlFor="ratingOne">
                        1
                      </label>
                    </div>
                  </div>
                  <div className="relative">
                    {/* <label className="sr-only">
                            2
                            </label> */}
                    <div className="client-servey-custom-radio">
                      <input
                        type="radio"
                        id="ratingTwo"
                        tabIndex={0}
                        name="q2rating"
                        value={2}
                        checked={q2rating === 2 ? true : false}
                        onChange={(e) => setq2rating(2)}
                      />
                      <label className="low" htmlFor="ratingTwo">
                        2
                      </label>
                    </div>
                  </div>
                  <div className="relative">
                    {/* <label htmlFor="ratingThree" className="sr-only">
                            3
                            </label> */}
                    <div className="client-servey-custom-radio">
                      <input
                        type="radio"
                        id="ratingThree"
                        tabIndex={0}
                        name="q2rating"
                        value={3}
                        checked={q2rating === 3 ? true : false}
                        onChange={(e) => setq2rating(3)}
                      />
                      <label className="low" htmlFor="ratingThree">
                        3
                      </label>
                    </div>
                  </div>
                  <div className="relative">
                    {/* <label htmlFor="ratingFour" className="sr-only">
                                4
                            </label> */}
                    <div className="client-servey-custom-radio">
                      <input
                        type="radio"
                        id="ratingFour"
                        tabIndex={0}
                        name="q2rating"
                        value={4}
                        checked={q2rating === 4 ? true : false}
                        onChange={(e) => setq2rating(4)}
                      />
                      <label className="low" htmlFor="ratingFour">
                        4
                      </label>
                    </div>
                  </div>
                  <div className="relative">
                    {/* <label htmlFor="ratingFive" className="sr-only">
                            5
                            </label> */}
                    <div className="client-servey-custom-radio">
                      <input
                        type="radio"
                        id="ratingFive"
                        tabIndex={0}
                        name="q2rating"
                        value={5}
                        checked={q2rating === 5 ? true : false}
                        onChange={(e) => setq2rating(5)}
                      />
                      <label className="low" htmlFor="ratingFive">
                        5
                      </label>
                    </div>
                  </div>
                  <div className="relative">
                    {/* <label htmlFor="ratingSix" className="sr-only">
                            6
                            </label> */}
                    <div className="client-servey-custom-radio">
                      <input
                        type="radio"
                        id="ratingSix"
                        tabIndex={0}
                        name="q2rating"
                        value={6}
                        checked={q2rating === 6 ? true : false}
                        onChange={(e) => setq2rating(6)}
                      />
                      <label className="low" htmlFor="ratingSix">
                        6
                      </label>
                    </div>
                  </div>
                  <div className="relative">
                    {/* <label htmlFor="ratingSeven" className="sr-only">
                            7
                            </label> */}
                    <div className="client-servey-custom-radio">
                      <input
                        type="radio"
                        id="ratingSeven"
                        tabIndex={0}
                        name="q2rating"
                        value={7}
                        checked={q2rating === 7 ? true : false}
                        onChange={(e) => setq2rating(7)}
                      />
                      <label className="medium" htmlFor="ratingSeven">
                        7
                      </label>
                    </div>
                  </div>
                  <div className="relative">
                    {/* <label htmlFor="ratingEight" className="sr-only">
                            8
                            </label> */}
                    <div className="client-servey-custom-radio">
                      <input
                        type="radio"
                        id="ratingEight"
                        tabIndex={0}
                        name="q2rating"
                        value={8}
                        checked={q2rating === 8 ? true : false}
                        onChange={(e) => setq2rating(8)}
                      />
                      <label className="medium" htmlFor="ratingEight">
                        8
                      </label>
                    </div>
                  </div>
                  <div className="relative">
                    {/* <label htmlFor="ratingNine" className="sr-only">
                            9
                            </label> */}
                    <div className="client-servey-custom-radio">
                      <input
                        type="radio"
                        id="ratingNine"
                        tabIndex={0}
                        name="q2rating"
                        value={9}
                        checked={q2rating === 9 ? true : false}
                        onChange={(e) => setq2rating(9)}
                      />
                      <label className="high" htmlFor="ratingNine">
                        9
                      </label>
                    </div>
                  </div>
                  <div className="relative">
                    {/* <label htmlFor="ratingTen" className="sr-only">
                            10
                            </label> */}
                    <div className="client-servey-custom-radio">
                      <input
                        type="radio"
                        id="ratingTen"
                        tabIndex={0}
                        name="q2rating"
                        value={10}
                        checked={q2rating === 10 ? true : false}
                        onChange={(e) => setq2rating(10)}
                      />
                      <label className="high" htmlFor="ratingTen">
                        10
                      </label>
                    </div>
                  </div>
                </div>
                <p
                  className="text-center text-gray-600"
                  style={{ fontSize: "16px" }}
                >
                  {intl.formatMessage({
                    id: "client-survey-how-likely-note",
                  })}
                </p>
                <div className="max-w-2xl mx-auto mt-12">
                  <label className="form-input-label">
                    {intl.formatMessage({
                      id: "client-survey-how-satisfied-with-service-question",
                    })}
                  </label>
                  <div className="mt-1">
                    <textarea
                      id="q2notes"
                      className="form-control client-servey-textarea form-control-client-servey"
                      rows={4}
                      value={q2notes}
                      onChange={(e) => setq2notes(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </section>
            <footer className="sticky inset-x-0 bottom-0 z-20 w-full py-6 mt-auto bg-white border-t border-gray-200">
              <div className="max-w-4xl px-4 mx-auto sm:px-6 lg:px-0 client-servey-less-padding">
                <div className="relative flex items-center justify-between">
                  <button
                    onClick={(e) => gotoPreviousStep(1)}
                    className="btn btn-gray btn-gray-client-servey client-survey-previous-btn"
                  >
                    {intl.formatMessage({ id: "previous" })}
                  </button>
                  <div className="absolute inset-0 py-2 -translate-x-1/2 left-half">
                    <nav
                      className="flex items-center justify-center"
                      aria-label="Progress"
                    >
                      <p className="text-sm font-medium">
                        {intl.formatMessage(
                          { id: "step-of" },
                          { step: 2, total: 7 }
                        )}
                      </p>
                      <ol className="items-center hidden ml-8 space-x-5 sm:flex">
                        <li>
                          <div className="relative flex items-center justify-center">
                            <span
                              className="absolute flex w-5 h-5 p-px"
                              aria-hidden="true"
                            >
                              <span className="w-full h-full rounded-full bg-rose-200" />
                            </span>
                            <span
                              className="relative block w-2.5 h-2.5 bg-rose-600 rounded-full"
                              aria-hidden="true"
                            />
                            <span className="sr-only">
                              {intl.formatMessage({ id: "step" }, { step: 1 })}
                            </span>
                          </div>
                        </li>
                        <li>
                          <div
                            className="relative flex items-center justify-center"
                            aria-current="step"
                          >
                            <span
                              className="absolute flex w-5 h-5 p-px curntStepHighlight"
                              aria-hidden="true"
                            >
                              <span className="w-full h-full rounded-full bg-rose-200" />
                            </span>
                            <span
                              className="relative block w-2.5 h-2.5 bg-rose-600 rounded-full"
                              aria-hidden="true"
                            />
                            <span className="sr-only">
                              {intl.formatMessage({ id: "step" }, { step: 2 })}
                            </span>
                          </div>
                        </li>
                        <li>
                          <div className="block w-2.5 h-2.5 bg-gray-200 rounded-full hover:bg-gray-400">
                            <span className="sr-only">
                              {intl.formatMessage({ id: "step" }, { step: 3 })}
                            </span>
                          </div>
                        </li>
                        <li>
                          <div className="block w-2.5 h-2.5 bg-gray-200 rounded-full hover:bg-gray-400">
                            <span className="sr-only">
                              {intl.formatMessage({ id: "step" }, { step: 4 })}
                            </span>
                          </div>
                        </li>
                        <li>
                          <div className="block w-2.5 h-2.5 bg-gray-200 rounded-full hover:bg-gray-400">
                            <span className="sr-only">
                              {intl.formatMessage({ id: "step" }, { step: 5 })}
                            </span>
                          </div>
                        </li>
                        <li>
                          <div className="block w-2.5 h-2.5 bg-gray-200 rounded-full hover:bg-gray-400">
                            <span className="sr-only">
                              {intl.formatMessage({ id: "step" }, { step: 6 })}
                            </span>
                          </div>
                        </li>
                        <li>
                          <div className="block w-2.5 h-2.5 bg-gray-200 rounded-full hover:bg-gray-400">
                            <span className="sr-only">
                              {intl.formatMessage({ id: "step" }, { step: 7 })}
                            </span>
                          </div>
                        </li>
                      </ol>
                    </nav>
                  </div>
                  <button
                    id="next_page_1"
                    onClick={(e) => goToStep3Block(e)}
                    className="btn btn-primary client-survey-btn client-survey-next-btn"
                  >
                    {intl.formatMessage({ id: "next" })}
                  </button>
                </div>
              </div>
            </footer>
          </div>
        ) : isShowStep3Block === true ? (
          <div>
            <section className="w-full py-12 bg-white">
              <div className="max-w-4xl px-4 mx-auto sm:px-6 lg:px-0 client-servey-less-padding">
                <h1 className="max-w-2xl mx-auto text-2xl font-semibold text-center sm:text-3xl lg:text-4xl client-servey-question-font-size">
                  {intl.formatMessage({
                    id: "client-survey-how-satisfied-with-food",
                  })}
                </h1>
                <div className="relative z-0 flex flex-wrap items-center justify-center my-8 gap-x-4 gap-y-4">
                  <div className="relative">
                    {/* <label className="sr-only">
                            1
                            </label> */}
                    <div className="client-servey-custom-radio">
                      <input
                        type="radio"
                        id="ratingOne"
                        tabIndex={0}
                        name="q3rating"
                        value={1}
                        checked={q3rating === 1 ? true : false}
                        onChange={(e) => setq3rating(1)}
                      />
                      <label className="low" htmlFor="ratingOne">
                        1
                      </label>
                    </div>
                  </div>
                  <div className="relative">
                    {/* <label className="sr-only">
                            2
                            </label> */}
                    <div className="client-servey-custom-radio">
                      <input
                        type="radio"
                        id="ratingTwo"
                        tabIndex={0}
                        name="q3rating"
                        value={2}
                        checked={q3rating === 2 ? true : false}
                        onChange={(e) => setq3rating(2)}
                      />
                      <label className="low" htmlFor="ratingTwo">
                        2
                      </label>
                    </div>
                  </div>
                  <div className="relative">
                    {/* <label htmlFor="ratingThree" className="sr-only">
                            3
                            </label> */}
                    <div className="client-servey-custom-radio">
                      <input
                        type="radio"
                        id="ratingThree"
                        tabIndex={0}
                        name="q3rating"
                        value={3}
                        checked={q3rating === 3 ? true : false}
                        onChange={(e) => setq3rating(3)}
                      />
                      <label className="low" htmlFor="ratingThree">
                        3
                      </label>
                    </div>
                  </div>
                  <div className="relative">
                    {/* <label htmlFor="ratingFour" className="sr-only">
                                4
                            </label> */}
                    <div className="client-servey-custom-radio">
                      <input
                        type="radio"
                        id="ratingFour"
                        tabIndex={0}
                        name="q3rating"
                        value={4}
                        checked={q3rating === 4 ? true : false}
                        onChange={(e) => setq3rating(4)}
                      />
                      <label className="low" htmlFor="ratingFour">
                        4
                      </label>
                    </div>
                  </div>
                  <div className="relative">
                    {/* <label htmlFor="ratingFive" className="sr-only">
                            5
                            </label> */}
                    <div className="client-servey-custom-radio">
                      <input
                        type="radio"
                        id="ratingFive"
                        tabIndex={0}
                        name="q3rating"
                        value={5}
                        checked={q3rating === 5 ? true : false}
                        onChange={(e) => setq3rating(5)}
                      />
                      <label className="low" htmlFor="ratingFive">
                        5
                      </label>
                    </div>
                  </div>
                  <div className="relative">
                    {/* <label htmlFor="ratingSix" className="sr-only">
                            6
                            </label> */}
                    <div className="client-servey-custom-radio">
                      <input
                        type="radio"
                        id="ratingSix"
                        tabIndex={0}
                        name="q3rating"
                        value={6}
                        checked={q3rating === 6 ? true : false}
                        onChange={(e) => setq3rating(6)}
                      />
                      <label className="low" htmlFor="ratingSix">
                        6
                      </label>
                    </div>
                  </div>
                  <div className="relative">
                    {/* <label htmlFor="ratingSeven" className="sr-only">
                            7
                            </label> */}
                    <div className="client-servey-custom-radio">
                      <input
                        type="radio"
                        id="ratingSeven"
                        tabIndex={0}
                        name="q3rating"
                        value={7}
                        checked={q3rating === 7 ? true : false}
                        onChange={(e) => setq3rating(7)}
                      />
                      <label className="medium" htmlFor="ratingSeven">
                        7
                      </label>
                    </div>
                  </div>
                  <div className="relative">
                    {/* <label htmlFor="ratingEight" className="sr-only">
                            8
                            </label> */}
                    <div className="client-servey-custom-radio">
                      <input
                        type="radio"
                        id="ratingEight"
                        tabIndex={0}
                        name="q3rating"
                        value={8}
                        checked={q3rating === 8 ? true : false}
                        onChange={(e) => setq3rating(8)}
                      />
                      <label className="medium" htmlFor="ratingEight">
                        8
                      </label>
                    </div>
                  </div>
                  <div className="relative">
                    {/* <label htmlFor="ratingNine" className="sr-only">
                            9
                            </label> */}
                    <div className="client-servey-custom-radio">
                      <input
                        type="radio"
                        id="ratingNine"
                        tabIndex={0}
                        name="q3rating"
                        value={9}
                        checked={q3rating === 9 ? true : false}
                        onChange={(e) => setq3rating(9)}
                      />
                      <label className="high" htmlFor="ratingNine">
                        9
                      </label>
                    </div>
                  </div>
                  <div className="relative">
                    {/* <label htmlFor="ratingTen" className="sr-only">
                            10
                            </label> */}
                    <div className="client-servey-custom-radio">
                      <input
                        type="radio"
                        id="ratingTen"
                        tabIndex={0}
                        name="q3rating"
                        value={10}
                        checked={q3rating === 10 ? true : false}
                        onChange={(e) => setq3rating(10)}
                      />
                      <label className="high" htmlFor="ratingTen">
                        10
                      </label>
                    </div>
                  </div>
                </div>
                <p
                  className="text-center text-gray-600"
                  style={{ fontSize: "16px" }}
                >
                  {intl.formatMessage({
                    id: "client-survey-how-likely-note",
                  })}
                </p>
                <div className="max-w-2xl mx-auto mt-12">
                  <label className="form-input-label">
                    {intl.formatMessage({
                      id: "client-survey-how-satisfied-with-food-question",
                    })}
                  </label>
                  <div className="mt-1">
                    <textarea
                      id="q3notes"
                      className="form-control client-servey-textarea form-control-client-servey"
                      rows={4}
                      value={q3notes}
                      onChange={(e) => setq3notes(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </section>
            <footer className="sticky inset-x-0 bottom-0 z-20 w-full py-6 mt-auto bg-white border-t border-gray-200">
              <div className="max-w-4xl px-4 mx-auto sm:px-6 lg:px-0 client-servey-less-padding">
                <div className="relative flex items-center justify-between">
                  <button
                    onClick={(e) => gotoPreviousStep(2)}
                    className="btn btn-gray btn-gray-client-servey client-survey-previous-btn"
                  >
                    {intl.formatMessage({ id: "previous" })}
                  </button>
                  <div className="absolute inset-0 py-2 -translate-x-1/2 left-half">
                    <nav
                      className="flex items-center justify-center"
                      aria-label="Progress"
                    >
                      <p className="text-sm font-medium">
                        {intl.formatMessage(
                          { id: "step-of" },
                          { step: 3, total: 7 }
                        )}
                      </p>
                      <ol className="items-center hidden ml-8 space-x-5 sm:flex">
                        <li>
                          <div className="relative flex items-center justify-center">
                            <span className="absolute flex w-5 h-5 p-px">
                              <span className="w-full h-full rounded-full bg-rose-200" />
                            </span>
                            <span className="relative block w-2.5 h-2.5 bg-rose-600 rounded-full" />
                            <span className="sr-only">
                              {intl.formatMessage({ id: "step" }, { step: 1 })}
                            </span>
                          </div>
                        </li>
                        <li>
                          <div className="block w-2.5 h-2.5 rounded-full bg-rose-600">
                            <span
                              className="absolute flex w-5 h-5 p-px"
                              aria-hidden="true"
                            >
                              <span className="w-full h-full rounded-full bg-rose-200" />
                            </span>
                            <span
                              className="relative block w-2.5 h-2.5 bg-rose-600 rounded-full"
                              aria-hidden="true"
                            />
                            <span className="sr-only">
                              {intl.formatMessage({ id: "step" }, { step: 2 })}
                            </span>
                          </div>
                        </li>
                        <li>
                          <div
                            className="relative flex items-center justify-center"
                            aria-current="step"
                          >
                            <span
                              className="absolute flex w-5 h-5 p-px curntStepHighlight"
                              aria-hidden="true"
                            >
                              <span className="w-full h-full rounded-full bg-rose-200" />
                            </span>
                            <span
                              className="relative block w-2.5 h-2.5 bg-rose-600 rounded-full"
                              aria-hidden="true"
                            />
                            <span className="sr-only">
                              {intl.formatMessage({ id: "step" }, { step: 3 })}
                            </span>
                          </div>
                        </li>
                        <li>
                          <div className="block w-2.5 h-2.5 bg-gray-200 rounded-full hover:bg-gray-400">
                            <span className="sr-only">
                              {intl.formatMessage({ id: "step" }, { step: 4 })}
                            </span>
                          </div>
                        </li>
                        <li>
                          <div className="block w-2.5 h-2.5 bg-gray-200 rounded-full hover:bg-gray-400">
                            <span className="sr-only">
                              {intl.formatMessage({ id: "step" }, { step: 5 })}
                            </span>
                          </div>
                        </li>
                        <li>
                          <div className="block w-2.5 h-2.5 bg-gray-200 rounded-full hover:bg-gray-400">
                            <span className="sr-only">
                              {intl.formatMessage({ id: "step" }, { step: 6 })}
                            </span>
                          </div>
                        </li>
                        <li>
                          <div className="block w-2.5 h-2.5 bg-gray-200 rounded-full hover:bg-gray-400">
                            <span className="sr-only">
                              {intl.formatMessage({ id: "step" }, { step: 7 })}
                            </span>
                          </div>
                        </li>
                      </ol>
                    </nav>
                  </div>
                  <button
                    onClick={(e) => goToStep4Block(e)}
                    className="btn btn-primary client-survey-btn client-survey-next-btn"
                  >
                    {intl.formatMessage({ id: "next" })}
                  </button>
                </div>
              </div>
            </footer>
          </div>
        ) : isShowStep4Block === true ? (
          <div>
            <section className="w-full py-12 bg-white">
              <div className="max-w-4xl px-4 mx-auto sm:px-6 lg:px-0">
                <h1 className="max-w-2xl mx-auto text-2xl font-semibold text-center sm:text-3xl lg:text-4xl client-servey-question-font-size">
                  {intl.formatMessage({
                    id: "client-survey-what-is-the-best-thing-about-working-with-us",
                  })}
                </h1>
                <div className="grid items-stretch grid-cols-2 gap-6 mt-8 lg-grid-cols-4">
                  <div className="relative flex-1 sm-flex-none">
                    <div className="client-servey-custom-checkbox green">
                      <input
                        type="checkbox"
                        name="value_4[]"
                        defaultValue="Management Team"
                        id="managementTeam"
                        tabIndex={0}
                        className="value_4"
                        onChange={handleQ4MattersCheckbox}
                        checked={
                          q4SelectedMatters.filter(
                            (obj) => obj === "Management Team"
                          ).length > 0
                            ? true
                            : false
                        }
                      />
                      <label htmlFor="managementTeam">
                        <div className="client-servey-checkbox-px-4 client-servey-checkbox-py-5 sm-py-6">
                          <svg
                            className="w-8 h-8 mx-auto"
                            viewBox="0 0 32 32"
                            fill="currentColor"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M18.6715 12.6666C18.6715 10.8257 20.1643 9.33331 22.0058 9.33331C23.8473 9.33331 25.3401 10.8257 25.3401 12.6666C25.3401 14.5076 23.8473 16 22.0058 16C20.1643 16 18.6715 14.5076 18.6715 12.6666ZM12.0028 14.6666C14.2126 14.6666 16.004 12.8758 16.004 10.6666C16.004 8.4575 14.2126 6.66664 12.0028 6.66664C9.79297 6.66664 8.00157 8.4575 8.00157 10.6666C8.00157 12.8758 9.79297 14.6666 12.0028 14.6666ZM19.2716 19.5466C18.593 18.1878 17.2032 17.3303 15.6839 17.3333H8.32166C6.8024 17.3303 5.41251 18.1878 4.73391 19.5466L2.81333 23.4C2.60531 23.8127 2.62588 24.3036 2.8677 24.6975C3.10952 25.0913 3.53809 25.3319 4.00036 25.3333H20.0052C20.4675 25.3319 20.896 25.0913 21.1379 24.6975C21.3797 24.3036 21.4002 23.8127 21.1922 23.4L19.2716 19.5466ZM29.1946 23.4L27.9276 20.8666C27.2474 19.5172 25.8647 18.6662 24.3532 18.6666H21.8057L23.5796 22.2133C24.0669 23.1831 24.1391 24.3092 23.7797 25.3333H28.0076C28.4699 25.3319 28.8985 25.0913 29.1403 24.6975C29.3821 24.3036 29.4027 23.8127 29.1946 23.4Z" />
                          </svg>
                          <span className="block mt-2 font-medium">
                            {intl.formatMessage({
                              id: "management-team",
                            })}
                          </span>
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="relative flex-1 sm-flex-none">
                    <div className="client-servey-custom-checkbox green">
                      <input
                        type="checkbox"
                        id="operationsTeam"
                        tabIndex={0}
                        name="value_4[]"
                        defaultValue="The front line operations team"
                        onChange={handleQ4MattersCheckbox}
                        checked={
                          q4SelectedMatters.filter(
                            (obj) => obj === "The front line operations team"
                          ).length > 0
                            ? true
                            : false
                        }
                      />
                      <label htmlFor="operationsTeam">
                        <div className="client-servey-checkbox-px-4 client-servey-checkbox-py-5 sm-py-6">
                          <svg
                            className="w-8 h-8 mx-auto"
                            viewBox="0 0 32 32"
                            fill="currentColor"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M6.66817 10.6666C6.66817 8.4575 8.45952 6.66664 10.6693 6.66664C12.879 6.66664 14.6704 8.4575 14.6704 10.6666C14.6704 12.8758 12.879 14.6666 10.6693 14.6666C8.45952 14.6666 6.66817 12.8758 6.66817 10.6666ZM21.3389 14.6666C23.5486 14.6666 25.34 12.8758 25.34 10.6666C25.34 8.4575 23.5486 6.66664 21.3389 6.66664C19.1291 6.66664 17.3378 8.4575 17.3378 10.6666C17.3378 12.8758 19.1291 14.6666 21.3389 14.6666ZM30.5281 23.4L28.6075 19.5466C27.9311 18.1921 26.5476 17.3354 25.0332 17.3333H19.6984C19.9425 17.6507 20.1568 17.9899 20.3386 18.3466L22.2725 22.2133C22.751 23.1868 22.8136 24.3128 22.4458 25.3333H29.3411C29.8033 25.3319 30.2319 25.0913 30.4737 24.6975C30.7155 24.3036 30.7361 23.8127 30.5281 23.4ZM17.9379 19.5466C17.2593 18.1878 15.8695 17.3303 14.3503 17.3333H6.98826C5.46904 17.3303 4.07919 18.1878 3.4006 19.5466L1.48007 23.4C1.27206 23.8127 1.29263 24.3036 1.53444 24.6975C1.77625 25.0913 2.20482 25.3319 2.66707 25.3333H18.6715C19.1337 25.3319 19.5623 25.0913 19.8041 24.6975C20.0459 24.3036 20.0665 23.8127 19.8585 23.4L17.9379 19.5466Z" />
                          </svg>
                          <span className="block mt-2 font-medium">
                            {intl.formatMessage({
                              id: "the-front-line-operations-team",
                            })}
                          </span>
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="relative flex-1 sm-flex-none">
                    <div className="client-servey-custom-checkbox green">
                      <input
                        type="checkbox"
                        id="foodOffering"
                        tabIndex={0}
                        name="value_4[]"
                        defaultValue="Food offering"
                        onChange={handleQ4MattersCheckbox}
                        checked={
                          q4SelectedMatters.filter(
                            (obj) => obj === "Food offering"
                          ).length > 0
                            ? true
                            : false
                        }
                      />
                      <label htmlFor="foodOffering">
                        <div className="client-servey-checkbox-px-4 client-servey-checkbox-py-5 sm-py-6">
                          <svg
                            className="w-8 h-8 mx-auto"
                            viewBox="0 0 32 32"
                            fill="currentColor"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M16 3.83331V14.8466C15.9991 15.9072 15.5771 16.9239 14.8267 17.6733L13.72 18.78C13.4717 19.0263 13.1365 19.1652 12.7867 19.1666H12V29.1666C12 29.5348 11.7016 29.8333 11.3334 29.8333H10C9.63185 29.8333 9.33337 29.5348 9.33337 29.1666V19.1666H8.54671C8.19692 19.1652 7.86172 19.0263 7.61337 18.78L6.50671 17.6733C5.75635 16.9239 5.33431 15.9072 5.33337 14.8466V3.83331C5.33337 3.46512 5.63185 3.16664 6.00004 3.16664H7.00004C7.36823 3.16664 7.66671 3.46512 7.66671 3.83331V13.1666C7.66671 13.5348 7.96518 13.8333 8.33337 13.8333H8.82671C9.1949 13.8333 9.49337 13.5348 9.49337 13.1666V3.83331C9.49337 3.46512 9.79185 3.16664 10.16 3.16664H11.1734C11.5416 3.16664 11.84 3.46512 11.84 3.83331V13.1666C11.84 13.5348 12.1385 13.8333 12.5067 13.8333H13C13.3682 13.8333 13.6667 13.5348 13.6667 13.1666V3.83331C13.6667 3.46512 13.9652 3.16664 14.3334 3.16664H15.3334C15.7016 3.16664 16 3.46512 16 3.83331ZM26.6667 3.83331C26.6667 3.46512 26.3682 3.16664 26 3.16664H25.3334C22.3879 3.16664 20 5.55446 20 8.49997V17.8333C20 18.5697 20.597 19.1666 21.3334 19.1666H24V29.1666C24 29.5348 24.2985 29.8333 24.6667 29.8333H26C26.3682 29.8333 26.6667 29.5348 26.6667 29.1666V3.83331Z" />
                          </svg>
                          <span className="block mt-2 font-medium">
                            {intl.formatMessage({ id: "food-offering" })}
                          </span>
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="relative flex-1 sm-flex-none">
                    <div className="client-servey-custom-checkbox green">
                      <input
                        type="checkbox"
                        id="innovation"
                        tabIndex={0}
                        name="value_4[]"
                        defaultValue="Innovation"
                        onChange={handleQ4MattersCheckbox}
                        checked={
                          q4SelectedMatters.filter(
                            (obj) => obj === "Innovation"
                          ).length > 0
                            ? true
                            : false
                        }
                      />
                      <label htmlFor="innovation">
                        <div className="client-servey-checkbox-px-4 client-servey-checkbox-py-5 sm-py-6">
                          <svg
                            className="w-8 h-8 mx-auto"
                            viewBox="0 0 32 32"
                            fill="currentColor"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M4.66665 17.8334H1.99998C1.82317 17.8334 1.6536 17.7631 1.52858 17.6381C1.40355 17.5131 1.33331 17.3435 1.33331 17.1667V15.8334C1.33331 15.6565 1.40355 15.487 1.52858 15.362C1.6536 15.2369 1.82317 15.1667 1.99998 15.1667H4.66665C4.84346 15.1667 5.01303 15.2369 5.13805 15.362C5.26307 15.487 5.33331 15.6565 5.33331 15.8334V17.1667C5.33331 17.3435 5.26307 17.5131 5.13805 17.6381C5.01303 17.7631 4.84346 17.8334 4.66665 17.8334ZM7.03998 9.43336C7.16744 9.56037 7.34004 9.63169 7.51998 9.63169C7.69992 9.63169 7.87252 9.56037 7.99998 9.43336L8.93331 8.50002C9.05631 8.37316 9.1251 8.20339 9.1251 8.02669C9.1251 7.84999 9.05631 7.68022 8.93331 7.55336L7.03998 5.66003C6.98013 5.59625 6.90784 5.54542 6.82757 5.51067C6.74731 5.47593 6.66077 5.458 6.57331 5.458C6.48585 5.458 6.39932 5.47593 6.31905 5.51067C6.23879 5.54542 6.1665 5.59625 6.10665 5.66003L5.15998 6.60669C5.0962 6.66655 5.04538 6.73884 5.01063 6.8191C4.97588 6.89936 4.95795 6.9859 4.95795 7.07336C4.95795 7.16082 4.97588 7.24735 5.01063 7.32762C5.04538 7.40788 5.0962 7.48017 5.15998 7.54003L7.03998 9.43336ZM24 9.43336C24.1268 9.55636 24.2966 9.62514 24.4733 9.62514C24.65 9.62514 24.8198 9.55636 24.9466 9.43336L26.8266 7.54003C26.8904 7.48017 26.9412 7.40788 26.976 7.32762C27.0107 7.24735 27.0287 7.16082 27.0287 7.07336C27.0287 6.9859 27.0107 6.89936 26.976 6.8191C26.9412 6.73884 26.8904 6.66655 26.8266 6.60669L25.88 5.66003C25.8201 5.59625 25.7478 5.54542 25.6676 5.51067C25.5873 5.47593 25.5008 5.458 25.4133 5.458C25.3258 5.458 25.2393 5.47593 25.1591 5.51067C25.0788 5.54542 25.0065 5.59625 24.9466 5.66003L23.0666 7.54003C22.9436 7.66689 22.8749 7.83666 22.8749 8.01336C22.8749 8.19006 22.9436 8.35982 23.0666 8.48669L24 9.43336ZM7.99998 23.5667C7.87311 23.4437 7.70335 23.3749 7.52665 23.3749C7.34994 23.3749 7.18018 23.4437 7.05331 23.5667L5.15998 25.46C5.0962 25.5199 5.04538 25.5922 5.01063 25.6724C4.97588 25.7527 4.95795 25.8392 4.95795 25.9267C4.95795 26.0142 4.97588 26.1007 5.01063 26.181C5.04538 26.2612 5.0962 26.3335 5.15998 26.3934L6.10665 27.34C6.1665 27.4038 6.23879 27.4546 6.31905 27.4894C6.39932 27.5241 6.48585 27.542 6.57331 27.542C6.66077 27.542 6.74731 27.5241 6.82757 27.4894C6.90784 27.4546 6.98013 27.4038 7.03998 27.34L8.93331 25.46C9.05631 25.3332 9.1251 25.1634 9.1251 24.9867C9.1251 24.81 9.05631 24.6402 8.93331 24.5134L7.99998 23.5667ZM18.6666 3.71336C18.6652 3.36357 18.5263 3.02837 18.28 2.78003L17.72 2.22003C17.4716 1.9737 17.1364 1.83483 16.7866 1.83336H15.2133C14.8635 1.83483 14.5283 1.9737 14.28 2.22003L13.72 2.78003C13.4737 3.02837 13.3348 3.36357 13.3333 3.71336V4.50003H18.6666V3.71336ZM24 16.5C24.0012 17.8914 23.6396 19.2591 22.9507 20.468C22.2618 21.6769 21.2696 22.6852 20.0719 23.3934C18.8742 24.1016 17.5126 24.4852 16.1213 24.5063C14.7301 24.5274 13.3574 24.1853 12.1388 23.5138C10.9202 22.8422 9.8978 21.8644 9.17258 20.677C8.44736 19.4895 8.04439 18.1335 8.00345 16.7427C7.9625 15.3519 8.28501 13.9744 8.93912 12.7464C9.59323 11.5183 10.5563 10.4821 11.7333 9.74002C12.0211 9.56157 12.2581 9.31206 12.4216 9.0155C12.585 8.71894 12.6694 8.38531 12.6666 8.04669V7.83336C12.6666 7.65655 12.7369 7.48698 12.8619 7.36195C12.9869 7.23693 13.1565 7.16669 13.3333 7.16669H18.6666C18.8435 7.16669 19.013 7.23693 19.1381 7.36195C19.2631 7.48698 19.3333 7.65655 19.3333 7.83336V8.04669C19.3331 8.38483 19.4185 8.71751 19.5818 9.01364C19.745 9.30977 19.9806 9.55969 20.2666 9.74002C21.4089 10.4602 22.3502 11.4577 23.003 12.6397C23.6558 13.8217 23.9988 15.1497 24 16.5ZM17.3333 19.8334C17.3333 19.6565 17.2631 19.487 17.1381 19.362C17.013 19.2369 16.8435 19.1667 16.6666 19.1667H15.3333C15.1565 19.1667 14.9869 19.2369 14.8619 19.362C14.7369 19.487 14.6666 19.6565 14.6666 19.8334V21.1667C14.6666 21.3435 14.7369 21.5131 14.8619 21.6381C14.9869 21.7631 15.1565 21.8334 15.3333 21.8334H16.6666C16.8435 21.8334 17.013 21.7631 17.1381 21.6381C17.2631 21.5131 17.3333 21.3435 17.3333 21.1667V19.8334ZM17.5733 11.9134C17.5847 11.8193 17.5759 11.724 17.5475 11.6336C17.5191 11.5433 17.4718 11.46 17.4088 11.3893C17.3457 11.3187 17.2683 11.2623 17.1817 11.2239C17.0951 11.1855 17.0014 11.166 16.9066 11.1667H15.0933C14.9986 11.166 14.9048 11.1855 14.8183 11.2239C14.7317 11.2623 14.6543 11.3187 14.5912 11.3893C14.5281 11.46 14.4808 11.5433 14.4524 11.6336C14.4241 11.724 14.4153 11.8193 14.4266 11.9134L14.96 16.2067C14.9698 16.288 15.0092 16.3628 15.0707 16.4169C15.1322 16.471 15.2114 16.5006 15.2933 16.5H16.7066C16.7885 16.5006 16.8678 16.471 16.9293 16.4169C16.9907 16.3628 17.0302 16.288 17.04 16.2067L17.5733 11.9134ZM30 15.1667H27.3333C27.1565 15.1667 26.9869 15.2369 26.8619 15.362C26.7369 15.487 26.6666 15.6565 26.6666 15.8334V17.1667C26.6666 17.3435 26.7369 17.5131 26.8619 17.6381C26.9869 17.7631 27.1565 17.8334 27.3333 17.8334H30C30.1768 17.8334 30.3464 17.7631 30.4714 17.6381C30.5964 17.5131 30.6666 17.3435 30.6666 17.1667V15.8334C30.6666 15.6565 30.5964 15.487 30.4714 15.362C30.3464 15.2369 30.1768 15.1667 30 15.1667ZM16.6666 27.1667H15.3333C15.1565 27.1667 14.9869 27.2369 14.8619 27.362C14.7369 27.487 14.6666 27.6565 14.6666 27.8334V30.5C14.6666 30.6768 14.7369 30.8464 14.8619 30.9714C14.9869 31.0965 15.1565 31.1667 15.3333 31.1667H16.6666C16.8435 31.1667 17.013 31.0965 17.1381 30.9714C17.2631 30.8464 17.3333 30.6768 17.3333 30.5V27.8334C17.3333 27.6565 17.2631 27.487 17.1381 27.362C17.013 27.2369 16.8435 27.1667 16.6666 27.1667ZM24.96 23.5667C24.8331 23.4437 24.6633 23.3749 24.4866 23.3749C24.3099 23.3749 24.1402 23.4437 24.0133 23.5667L23.0666 24.5C22.9436 24.6269 22.8749 24.7967 22.8749 24.9734C22.8749 25.1501 22.9436 25.3198 23.0666 25.4467L24.96 27.3267C25.0198 27.3905 25.0921 27.4413 25.1724 27.476C25.2526 27.5108 25.3392 27.5287 25.4266 27.5287C25.5141 27.5287 25.6006 27.5108 25.6809 27.476C25.7612 27.4413 25.8335 27.3905 25.8933 27.3267L26.84 26.38C26.9038 26.3202 26.9546 26.2479 26.9893 26.1676C27.0241 26.0874 27.042 26.0008 27.042 25.9134C27.042 25.8259 27.0241 25.7394 26.9893 25.6591C26.9546 25.5788 26.9038 25.5065 26.84 25.4467L24.96 23.5667Z" />
                          </svg>
                          <span className="block mt-2 font-medium">
                            {intl.formatMessage({ id: "innovation" })}
                          </span>
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="relative flex-1 sm-flex-none">
                    <div className="client-servey-custom-checkbox green">
                      <input
                        type="checkbox"
                        id="communication"
                        tabIndex={0}
                        name="value_4[]"
                        defaultValue="Communication"
                        onChange={handleQ4MattersCheckbox}
                        checked={
                          q4SelectedMatters.filter(
                            (obj) => obj === "Communication"
                          ).length > 0
                            ? true
                            : false
                        }
                      />
                      <label htmlFor="communication">
                        <div className="client-servey-checkbox-px-4 client-servey-checkbox-py-5 sm-py-6">
                          <svg
                            className="w-8 h-8 mx-auto"
                            viewBox="0 0 32 32"
                            fill="currentColor"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M20.017 21.8067C22.9652 21.8067 25.3552 19.4223 25.3552 16.481V8.49237C25.3552 5.55106 22.9652 3.16665 20.017 3.16665H6.67156C3.72336 3.16665 1.33337 5.55106 1.33337 8.49237V25.1353C1.33337 25.5029 1.63212 25.801 2.00065 25.801C2.17696 25.8 2.3454 25.7279 2.46774 25.6013L5.13683 22.9384C5.9033 22.1939 6.93654 21.7863 8.00611 21.8067H20.017ZM28.0243 8.49237V19.1438C28.0243 22.0851 25.6343 24.4695 22.6861 24.4695H6.67156C6.67156 25.9402 7.86655 27.1324 9.34065 27.1324H24.0207C25.0868 27.1298 26.1099 27.5515 26.8632 28.3041L29.5323 30.9669C29.6547 31.0936 29.8231 31.1656 29.9994 31.1666C30.368 31.1666 30.6667 30.8686 30.6667 30.5009V11.1552C30.6668 9.69491 29.488 8.50698 28.0243 8.49237Z" />
                          </svg>
                          <span className="block mt-2 font-medium">
                            {intl.formatMessage({ id: "communication" })}
                          </span>
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="relative flex-1 sm-flex-none">
                    <div className="client-servey-custom-checkbox green">
                      <input
                        type="checkbox"
                        id="flexibility"
                        tabIndex={0}
                        name="value_4[]"
                        defaultValue="Flexibility and responsiveness"
                        onChange={handleQ4MattersCheckbox}
                        checked={
                          q4SelectedMatters.filter(
                            (obj) => obj === "Flexibility and responsiveness"
                          ).length > 0
                            ? true
                            : false
                        }
                      />
                      <label htmlFor="flexibility">
                        <div className="client-servey-checkbox-px-4 client-servey-checkbox-py-5 sm-py-6">
                          <svg
                            className="w-8 h-8 mx-auto"
                            viewBox="0 0 32 32"
                            fill="currentColor"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M16 2.66665C8.63616 2.66665 2.66663 8.63619 2.66663 16C2.66663 23.3638 8.63616 29.3333 16 29.3333C23.3638 29.3333 29.3333 23.3638 29.3333 16C29.3333 12.4638 27.9285 9.07238 25.4281 6.57189C22.9276 4.07141 19.5362 2.66665 16 2.66665ZM22.0133 21.3333L21.3066 22.04C21.0429 22.2957 20.6237 22.2957 20.36 22.04L15.0266 16.7066C14.8964 16.5812 14.824 16.4074 14.8266 16.2266V8.66665C14.8266 8.29846 15.1251 7.99998 15.4933 7.99998H16.5066C16.8748 7.99998 17.1733 8.29846 17.1733 8.66665V15.52L22.0133 20.36C22.1444 20.488 22.2184 20.6634 22.2184 20.8466C22.2184 21.0299 22.1444 21.2053 22.0133 21.3333Z" />
                          </svg>
                          <span className="block mt-2 font-medium">
                            {intl.formatMessage({
                              id: "flexibility-and-responsiveness",
                            })}
                          </span>
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="relative flex-1 sm-flex-none">
                    <div className="client-servey-custom-checkbox green">
                      <input
                        type="checkbox"
                        id="billing"
                        tabIndex={0}
                        name="value_4[]"
                        defaultValue="Billing"
                        onChange={handleQ4MattersCheckbox}
                        checked={
                          q4SelectedMatters.filter((obj) => obj === "Billing")
                            .length > 0
                            ? true
                            : false
                        }
                      />
                      <label htmlFor="billing">
                        <div className="client-servey-checkbox-px-4 client-servey-checkbox-py-5 sm-py-6">
                          <svg
                            className="w-8 h-8 mx-auto"
                            viewBox="0 0 32 32"
                            fill="currentColor"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M8.24004 29.6333C8.36041 29.7628 8.5299 29.8355 8.70671 29.8333H9.09337C9.27018 29.8355 9.43967 29.7628 9.56004 29.6333L12 27.1666C12.2638 26.9109 12.683 26.9109 12.9467 27.1666L15.36 29.58C15.4804 29.7095 15.6499 29.7821 15.8267 29.78H16.2134C16.3902 29.7821 16.5597 29.7095 16.68 29.58L19.0934 27.1666C19.3515 26.9358 19.7419 26.9358 20 27.1666L22.4134 29.58C22.5337 29.7095 22.7032 29.7821 22.88 29.78H23.2667C23.4435 29.7821 23.613 29.7095 23.7334 29.58L26.28 27.1666C26.5264 26.9183 26.6652 26.5831 26.6667 26.2333V4.49998C26.6667 3.7636 26.0698 3.16665 25.3334 3.16665H6.66671C5.93033 3.16665 5.33337 3.7636 5.33337 4.49998V26.18C5.33829 26.533 5.4764 26.8711 5.72004 27.1266L8.24004 29.6333ZM17.3334 18.5C17.3334 18.8682 17.0349 19.1666 16.6667 19.1666H11.3334C10.9652 19.1666 10.6667 18.8682 10.6667 18.5V17.1666C10.6667 16.7985 10.9652 16.5 11.3334 16.5H16.6667C17.0349 16.5 17.3334 16.7985 17.3334 17.1666V18.5ZM21.3334 13.1666C21.3334 13.5348 21.0349 13.8333 20.6667 13.8333H11.3334C10.9652 13.8333 10.6667 13.5348 10.6667 13.1666V11.8333C10.6667 11.4651 10.9652 11.1666 11.3334 11.1666H20.6667C21.0349 11.1666 21.3334 11.4651 21.3334 11.8333V13.1666Z" />
                          </svg>
                          <span className="block mt-2 font-medium">
                            {intl.formatMessage({ id: "billing" })}
                          </span>
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="relative flex-1 sm-flex-none">
                    <div className="client-servey-custom-checkbox green">
                      <input
                        type="checkbox"
                        id="healthStandards"
                        tabIndex={0}
                        name="value_4[]"
                        defaultValue="Health and Hygiene Standards"
                        checked={
                          q4SelectedMatters.filter(
                            (obj) => obj === "Health and Hygiene Standards"
                          ).length > 0
                            ? true
                            : false
                        }
                        onChange={handleQ4MattersCheckbox}
                      />
                      <label htmlFor="healthStandards">
                        <div className="client-servey-checkbox-px-4 client-servey-checkbox-py-5 sm-py-6">
                          <svg
                            className="w-8 h-8 mx-auto"
                            viewBox="0 0 32 32"
                            fill="currentColor"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M28 5.33332C28 3.86056 26.8061 2.66665 25.3333 2.66665H9.33333C7.86057 2.66665 6.66667 3.86056 6.66667 5.33332H4.66667C4.29848 5.33332 4 5.63179 4 5.99998V7.33332C4 7.70151 4.29848 7.99998 4.66667 7.99998H6.66667V14.6666H4.66667C4.29848 14.6666 4 14.9651 4 15.3333V16.6666C4 17.0348 4.29848 17.3333 4.66667 17.3333H6.66667V24H4.66667C4.29848 24 4 24.2985 4 24.6666V26C4 26.3682 4.29848 26.6666 4.66667 26.6666H6.66667C6.66667 28.1394 7.86057 29.3333 9.33333 29.3333H25.3333C26.8061 29.3333 28 28.1394 28 26.6666V5.33332ZM18.9333 20.1066L17.8933 21.1066C17.5823 21.4116 17.0844 21.4116 16.7733 21.1066L15.7333 20.1066C14.5333 18.9333 12 16.6666 12 14.8533C12.0105 14.0859 12.3255 13.3542 12.8756 12.8191C13.4258 12.2839 14.166 11.9893 14.9333 12C15.8426 12.0256 16.705 12.4089 17.3333 13.0666C17.9616 12.4089 18.8241 12.0256 19.7333 12C20.5007 11.9893 21.2409 12.2839 21.791 12.8191C22.3411 13.3542 22.6561 14.0859 22.6667 14.8533C22.6667 16.6666 20.1333 18.9333 18.9333 20.1066Z" />
                          </svg>
                          <span className="block mt-2 font-medium">
                            {intl.formatMessage({
                              id: "health-and-hygiene-standards",
                            })}
                          </span>
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-span-2 lg:col-span-4">
                    <label className="cust-servey-sr-only cust-servey-sr-only-label">
                      {intl.formatMessage({ id: "if-other-please-specify" })}
                    </label>
                    <div className="mt-1">
                      <textarea
                        id="notes_value_4"
                        className="form-control form-control-client-servey"
                        rows={4}
                        placeholder={intl.formatMessage({
                          id: "if-other-please-specify",
                        })}
                        value={q4notes}
                        onChange={(e) => setq4notes(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <footer className="sticky inset-x-0 bottom-0 z-20 w-full py-6 mt-auto bg-white border-t border-gray-200">
              <div className="max-w-4xl px-4 mx-auto sm:px-6 lg:px-0 client-servey-less-padding">
                <div className="relative flex items-center justify-between">
                  <button
                    onClick={(e) => gotoPreviousStep(3)}
                    className="btn btn-gray btn-gray-client-servey client-survey-previous-btn"
                  >
                    {intl.formatMessage({ id: "previous" })}
                  </button>
                  <div className="absolute inset-0 py-2 -translate-x-1/2 left-half">
                    <nav
                      className="flex items-center justify-center"
                      aria-label="Progress"
                    >
                      <p className="text-sm font-medium">
                        {intl.formatMessage(
                          { id: "step-of" },
                          { step: 4, total: 7 }
                        )}
                      </p>
                      <ol className="items-center hidden ml-8 space-x-5 sm:flex">
                        <li>
                          <div className="relative flex items-center justify-center">
                            <span
                              className="absolute flex w-5 h-5 p-px"
                              aria-hidden="true"
                            >
                              <span className="w-full h-full rounded-full bg-rose-200" />
                            </span>
                            <span
                              className="relative block w-2.5 h-2.5 bg-rose-600 rounded-full"
                              aria-hidden="true"
                            />
                            <span className="sr-only">
                              {intl.formatMessage({ id: "step" }, { step: 1 })}
                            </span>
                          </div>
                        </li>
                        <li>
                          <div className="block w-2.5 h-2.5 rounded-full bg-rose-600">
                            <span
                              className="absolute flex w-5 h-5 p-px"
                              aria-hidden="true"
                            >
                              <span className="w-full h-full rounded-full bg-rose-200" />
                            </span>
                            <span
                              className="relative block w-2.5 h-2.5 bg-rose-600 rounded-full"
                              aria-hidden="true"
                            />
                            <span className="sr-only">
                              {intl.formatMessage({ id: "step" }, { step: 2 })}
                            </span>
                          </div>
                        </li>
                        <li>
                          <div className="block w-2.5 h-2.5 rounded-full bg-rose-600">
                            <span
                              className="absolute flex w-5 h-5 p-px"
                              aria-hidden="true"
                            >
                              <span className="w-full h-full rounded-full bg-rose-200" />
                            </span>
                            <span className="sr-only">
                              {intl.formatMessage({ id: "step" }, { step: 3 })}
                            </span>
                          </div>
                        </li>
                        <li>
                          <div
                            className="relative flex items-center justify-center"
                            aria-current="step"
                          >
                            <span
                              className="absolute flex w-5 h-5 p-px curntStepHighlight"
                              aria-hidden="true"
                            >
                              <span className="w-full h-full rounded-full bg-rose-200" />
                            </span>
                            <span
                              className="relative block w-2.5 h-2.5 bg-rose-600 rounded-full"
                              aria-hidden="true"
                            />
                            <span className="sr-only">
                              {intl.formatMessage({ id: "step" }, { step: 4 })}
                            </span>
                          </div>
                        </li>
                        <li>
                          <div className="block w-2.5 h-2.5 bg-gray-200 rounded-full hover:bg-gray-400">
                            <span className="sr-only">
                              {intl.formatMessage({ id: "step" }, { step: 5 })}
                            </span>
                          </div>
                        </li>
                        <li>
                          <div className="block w-2.5 h-2.5 bg-gray-200 rounded-full hover:bg-gray-400">
                            <span className="sr-only">
                              {intl.formatMessage({ id: "step" }, { step: 6 })}
                            </span>
                          </div>
                        </li>
                        <li>
                          <div className="block w-2.5 h-2.5 bg-gray-200 rounded-full hover:bg-gray-400">
                            <span className="sr-only">
                              {intl.formatMessage({ id: "step" }, { step: 7 })}
                            </span>
                          </div>
                        </li>
                      </ol>
                    </nav>
                  </div>
                  <button
                    onClick={(e) => goToStep5Block(e)}
                    className="btn btn-primary client-survey-btn client-survey-next-btn"
                  >
                    {intl.formatMessage({ id: "next" })}
                  </button>
                </div>
              </div>
            </footer>
          </div>
        ) : isShowStep5Block === true ? (
          <div>
            <section className="w-full py-12 bg-white">
              <div className="max-w-4xl px-4 mx-auto sm:px-6 lg:px-0">
                <h1 className="max-w-2xl mx-auto text-2xl font-semibold text-center sm:text-3xl lg:text-4xl client-servey-question-font-size">
                  {intl.formatMessage({
                    id: "based-on-the-service-we-provide-where-can-we-improve-the-most-please-select-all-that-matters",
                  })}
                </h1>
                <div className="grid items-stretch grid-cols-2 gap-6 mt-8 lg-grid-cols-4">
                  <div className="relative flex-1 sm-flex-none">
                    <div className="client-servey-custom-checkbox primary">
                      <input
                        type="checkbox"
                        name="value_5[]"
                        defaultValue="Management Team"
                        id="managementTeam-q5"
                        tabIndex={0}
                        onChange={handleQ5MattersCheckbox}
                        checked={
                          q5SelectedMatters.filter(
                            (obj) => obj === "Management Team"
                          ).length > 0
                            ? true
                            : false
                        }
                      />
                      <label htmlFor="managementTeam-q5">
                        <div className="client-servey-checkbox-px-4 client-servey-checkbox-py-5 sm-py-6">
                          <svg
                            className="w-8 h-8 mx-auto"
                            viewBox="0 0 32 32"
                            fill="currentColor"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M18.6715 12.6666C18.6715 10.8257 20.1643 9.33331 22.0058 9.33331C23.8473 9.33331 25.3401 10.8257 25.3401 12.6666C25.3401 14.5076 23.8473 16 22.0058 16C20.1643 16 18.6715 14.5076 18.6715 12.6666ZM12.0028 14.6666C14.2126 14.6666 16.004 12.8758 16.004 10.6666C16.004 8.4575 14.2126 6.66664 12.0028 6.66664C9.79297 6.66664 8.00157 8.4575 8.00157 10.6666C8.00157 12.8758 9.79297 14.6666 12.0028 14.6666ZM19.2716 19.5466C18.593 18.1878 17.2032 17.3303 15.6839 17.3333H8.32166C6.8024 17.3303 5.41251 18.1878 4.73391 19.5466L2.81333 23.4C2.60531 23.8127 2.62588 24.3036 2.8677 24.6975C3.10952 25.0913 3.53809 25.3319 4.00036 25.3333H20.0052C20.4675 25.3319 20.896 25.0913 21.1379 24.6975C21.3797 24.3036 21.4002 23.8127 21.1922 23.4L19.2716 19.5466ZM29.1946 23.4L27.9276 20.8666C27.2474 19.5172 25.8647 18.6662 24.3532 18.6666H21.8057L23.5796 22.2133C24.0669 23.1831 24.1391 24.3092 23.7797 25.3333H28.0076C28.4699 25.3319 28.8985 25.0913 29.1403 24.6975C29.3821 24.3036 29.4027 23.8127 29.1946 23.4Z" />
                          </svg>
                          <span className="block mt-2 font-medium">
                            {intl.formatMessage({ id: "management-team" })}
                          </span>
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="relative flex-1 sm-flex-none">
                    <div className="client-servey-custom-checkbox primary">
                      <input
                        type="checkbox"
                        id="operationsTeam-q5"
                        tabIndex={0}
                        name="value_5[]"
                        defaultValue="The front line operations team"
                        onChange={handleQ5MattersCheckbox}
                        checked={
                          q5SelectedMatters.filter(
                            (obj) => obj === "The front line operations team"
                          ).length > 0
                            ? true
                            : false
                        }
                      />
                      <label htmlFor="operationsTeam-q5">
                        <div className="client-servey-checkbox-px-4 client-servey-checkbox-py-5 sm-py-6">
                          <svg
                            className="w-8 h-8 mx-auto"
                            viewBox="0 0 32 32"
                            fill="currentColor"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M6.66817 10.6666C6.66817 8.4575 8.45952 6.66664 10.6693 6.66664C12.879 6.66664 14.6704 8.4575 14.6704 10.6666C14.6704 12.8758 12.879 14.6666 10.6693 14.6666C8.45952 14.6666 6.66817 12.8758 6.66817 10.6666ZM21.3389 14.6666C23.5486 14.6666 25.34 12.8758 25.34 10.6666C25.34 8.4575 23.5486 6.66664 21.3389 6.66664C19.1291 6.66664 17.3378 8.4575 17.3378 10.6666C17.3378 12.8758 19.1291 14.6666 21.3389 14.6666ZM30.5281 23.4L28.6075 19.5466C27.9311 18.1921 26.5476 17.3354 25.0332 17.3333H19.6984C19.9425 17.6507 20.1568 17.9899 20.3386 18.3466L22.2725 22.2133C22.751 23.1868 22.8136 24.3128 22.4458 25.3333H29.3411C29.8033 25.3319 30.2319 25.0913 30.4737 24.6975C30.7155 24.3036 30.7361 23.8127 30.5281 23.4ZM17.9379 19.5466C17.2593 18.1878 15.8695 17.3303 14.3503 17.3333H6.98826C5.46904 17.3303 4.07919 18.1878 3.4006 19.5466L1.48007 23.4C1.27206 23.8127 1.29263 24.3036 1.53444 24.6975C1.77625 25.0913 2.20482 25.3319 2.66707 25.3333H18.6715C19.1337 25.3319 19.5623 25.0913 19.8041 24.6975C20.0459 24.3036 20.0665 23.8127 19.8585 23.4L17.9379 19.5466Z" />
                          </svg>
                          <span className="block mt-2 font-medium">
                            {intl.formatMessage({
                              id: "the-front-line-operations-team",
                            })}
                          </span>
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="relative flex-1 sm-flex-none">
                    <div className="client-servey-custom-checkbox primary">
                      <input
                        type="checkbox"
                        id="foodOffering-q5"
                        tabIndex={0}
                        name="value_5[]"
                        defaultValue="Food offering"
                        onChange={handleQ5MattersCheckbox}
                        checked={
                          q5SelectedMatters.filter(
                            (obj) => obj === "Food offering"
                          ).length > 0
                            ? true
                            : false
                        }
                      />
                      <label htmlFor="foodOffering-q5">
                        <div className="client-servey-checkbox-px-4 client-servey-checkbox-py-5 sm-py-6">
                          <svg
                            className="w-8 h-8 mx-auto"
                            viewBox="0 0 32 32"
                            fill="currentColor"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M16 3.83331V14.8466C15.9991 15.9072 15.5771 16.9239 14.8267 17.6733L13.72 18.78C13.4717 19.0263 13.1365 19.1652 12.7867 19.1666H12V29.1666C12 29.5348 11.7016 29.8333 11.3334 29.8333H10C9.63185 29.8333 9.33337 29.5348 9.33337 29.1666V19.1666H8.54671C8.19692 19.1652 7.86172 19.0263 7.61337 18.78L6.50671 17.6733C5.75635 16.9239 5.33431 15.9072 5.33337 14.8466V3.83331C5.33337 3.46512 5.63185 3.16664 6.00004 3.16664H7.00004C7.36823 3.16664 7.66671 3.46512 7.66671 3.83331V13.1666C7.66671 13.5348 7.96518 13.8333 8.33337 13.8333H8.82671C9.1949 13.8333 9.49337 13.5348 9.49337 13.1666V3.83331C9.49337 3.46512 9.79185 3.16664 10.16 3.16664H11.1734C11.5416 3.16664 11.84 3.46512 11.84 3.83331V13.1666C11.84 13.5348 12.1385 13.8333 12.5067 13.8333H13C13.3682 13.8333 13.6667 13.5348 13.6667 13.1666V3.83331C13.6667 3.46512 13.9652 3.16664 14.3334 3.16664H15.3334C15.7016 3.16664 16 3.46512 16 3.83331ZM26.6667 3.83331C26.6667 3.46512 26.3682 3.16664 26 3.16664H25.3334C22.3879 3.16664 20 5.55446 20 8.49997V17.8333C20 18.5697 20.597 19.1666 21.3334 19.1666H24V29.1666C24 29.5348 24.2985 29.8333 24.6667 29.8333H26C26.3682 29.8333 26.6667 29.5348 26.6667 29.1666V3.83331Z" />
                          </svg>
                          <span className="block mt-2 font-medium">
                            {intl.formatMessage({ id: "food-offering" })}
                          </span>
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="relative flex-1 sm-flex-none">
                    <div className="client-servey-custom-checkbox primary">
                      <input
                        type="checkbox"
                        id="innovation-q5"
                        tabIndex={0}
                        name="value_5[]"
                        defaultValue="Innovation"
                        onChange={handleQ5MattersCheckbox}
                        checked={
                          q5SelectedMatters.filter(
                            (obj) => obj === "Innovation"
                          ).length > 0
                            ? true
                            : false
                        }
                      />
                      <label htmlFor="innovation-q5">
                        <div className="client-servey-checkbox-px-4 client-servey-checkbox-py-5 sm-py-6">
                          <svg
                            className="w-8 h-8 mx-auto"
                            viewBox="0 0 32 32"
                            fill="currentColor"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M4.66665 17.8334H1.99998C1.82317 17.8334 1.6536 17.7631 1.52858 17.6381C1.40355 17.5131 1.33331 17.3435 1.33331 17.1667V15.8334C1.33331 15.6565 1.40355 15.487 1.52858 15.362C1.6536 15.2369 1.82317 15.1667 1.99998 15.1667H4.66665C4.84346 15.1667 5.01303 15.2369 5.13805 15.362C5.26307 15.487 5.33331 15.6565 5.33331 15.8334V17.1667C5.33331 17.3435 5.26307 17.5131 5.13805 17.6381C5.01303 17.7631 4.84346 17.8334 4.66665 17.8334ZM7.03998 9.43336C7.16744 9.56037 7.34004 9.63169 7.51998 9.63169C7.69992 9.63169 7.87252 9.56037 7.99998 9.43336L8.93331 8.50002C9.05631 8.37316 9.1251 8.20339 9.1251 8.02669C9.1251 7.84999 9.05631 7.68022 8.93331 7.55336L7.03998 5.66003C6.98013 5.59625 6.90784 5.54542 6.82757 5.51067C6.74731 5.47593 6.66077 5.458 6.57331 5.458C6.48585 5.458 6.39932 5.47593 6.31905 5.51067C6.23879 5.54542 6.1665 5.59625 6.10665 5.66003L5.15998 6.60669C5.0962 6.66655 5.04538 6.73884 5.01063 6.8191C4.97588 6.89936 4.95795 6.9859 4.95795 7.07336C4.95795 7.16082 4.97588 7.24735 5.01063 7.32762C5.04538 7.40788 5.0962 7.48017 5.15998 7.54003L7.03998 9.43336ZM24 9.43336C24.1268 9.55636 24.2966 9.62514 24.4733 9.62514C24.65 9.62514 24.8198 9.55636 24.9466 9.43336L26.8266 7.54003C26.8904 7.48017 26.9412 7.40788 26.976 7.32762C27.0107 7.24735 27.0287 7.16082 27.0287 7.07336C27.0287 6.9859 27.0107 6.89936 26.976 6.8191C26.9412 6.73884 26.8904 6.66655 26.8266 6.60669L25.88 5.66003C25.8201 5.59625 25.7478 5.54542 25.6676 5.51067C25.5873 5.47593 25.5008 5.458 25.4133 5.458C25.3258 5.458 25.2393 5.47593 25.1591 5.51067C25.0788 5.54542 25.0065 5.59625 24.9466 5.66003L23.0666 7.54003C22.9436 7.66689 22.8749 7.83666 22.8749 8.01336C22.8749 8.19006 22.9436 8.35982 23.0666 8.48669L24 9.43336ZM7.99998 23.5667C7.87311 23.4437 7.70335 23.3749 7.52665 23.3749C7.34994 23.3749 7.18018 23.4437 7.05331 23.5667L5.15998 25.46C5.0962 25.5199 5.04538 25.5922 5.01063 25.6724C4.97588 25.7527 4.95795 25.8392 4.95795 25.9267C4.95795 26.0142 4.97588 26.1007 5.01063 26.181C5.04538 26.2612 5.0962 26.3335 5.15998 26.3934L6.10665 27.34C6.1665 27.4038 6.23879 27.4546 6.31905 27.4894C6.39932 27.5241 6.48585 27.542 6.57331 27.542C6.66077 27.542 6.74731 27.5241 6.82757 27.4894C6.90784 27.4546 6.98013 27.4038 7.03998 27.34L8.93331 25.46C9.05631 25.3332 9.1251 25.1634 9.1251 24.9867C9.1251 24.81 9.05631 24.6402 8.93331 24.5134L7.99998 23.5667ZM18.6666 3.71336C18.6652 3.36357 18.5263 3.02837 18.28 2.78003L17.72 2.22003C17.4716 1.9737 17.1364 1.83483 16.7866 1.83336H15.2133C14.8635 1.83483 14.5283 1.9737 14.28 2.22003L13.72 2.78003C13.4737 3.02837 13.3348 3.36357 13.3333 3.71336V4.50003H18.6666V3.71336ZM24 16.5C24.0012 17.8914 23.6396 19.2591 22.9507 20.468C22.2618 21.6769 21.2696 22.6852 20.0719 23.3934C18.8742 24.1016 17.5126 24.4852 16.1213 24.5063C14.7301 24.5274 13.3574 24.1853 12.1388 23.5138C10.9202 22.8422 9.8978 21.8644 9.17258 20.677C8.44736 19.4895 8.04439 18.1335 8.00345 16.7427C7.9625 15.3519 8.28501 13.9744 8.93912 12.7464C9.59323 11.5183 10.5563 10.4821 11.7333 9.74002C12.0211 9.56157 12.2581 9.31206 12.4216 9.0155C12.585 8.71894 12.6694 8.38531 12.6666 8.04669V7.83336C12.6666 7.65655 12.7369 7.48698 12.8619 7.36195C12.9869 7.23693 13.1565 7.16669 13.3333 7.16669H18.6666C18.8435 7.16669 19.013 7.23693 19.1381 7.36195C19.2631 7.48698 19.3333 7.65655 19.3333 7.83336V8.04669C19.3331 8.38483 19.4185 8.71751 19.5818 9.01364C19.745 9.30977 19.9806 9.55969 20.2666 9.74002C21.4089 10.4602 22.3502 11.4577 23.003 12.6397C23.6558 13.8217 23.9988 15.1497 24 16.5ZM17.3333 19.8334C17.3333 19.6565 17.2631 19.487 17.1381 19.362C17.013 19.2369 16.8435 19.1667 16.6666 19.1667H15.3333C15.1565 19.1667 14.9869 19.2369 14.8619 19.362C14.7369 19.487 14.6666 19.6565 14.6666 19.8334V21.1667C14.6666 21.3435 14.7369 21.5131 14.8619 21.6381C14.9869 21.7631 15.1565 21.8334 15.3333 21.8334H16.6666C16.8435 21.8334 17.013 21.7631 17.1381 21.6381C17.2631 21.5131 17.3333 21.3435 17.3333 21.1667V19.8334ZM17.5733 11.9134C17.5847 11.8193 17.5759 11.724 17.5475 11.6336C17.5191 11.5433 17.4718 11.46 17.4088 11.3893C17.3457 11.3187 17.2683 11.2623 17.1817 11.2239C17.0951 11.1855 17.0014 11.166 16.9066 11.1667H15.0933C14.9986 11.166 14.9048 11.1855 14.8183 11.2239C14.7317 11.2623 14.6543 11.3187 14.5912 11.3893C14.5281 11.46 14.4808 11.5433 14.4524 11.6336C14.4241 11.724 14.4153 11.8193 14.4266 11.9134L14.96 16.2067C14.9698 16.288 15.0092 16.3628 15.0707 16.4169C15.1322 16.471 15.2114 16.5006 15.2933 16.5H16.7066C16.7885 16.5006 16.8678 16.471 16.9293 16.4169C16.9907 16.3628 17.0302 16.288 17.04 16.2067L17.5733 11.9134ZM30 15.1667H27.3333C27.1565 15.1667 26.9869 15.2369 26.8619 15.362C26.7369 15.487 26.6666 15.6565 26.6666 15.8334V17.1667C26.6666 17.3435 26.7369 17.5131 26.8619 17.6381C26.9869 17.7631 27.1565 17.8334 27.3333 17.8334H30C30.1768 17.8334 30.3464 17.7631 30.4714 17.6381C30.5964 17.5131 30.6666 17.3435 30.6666 17.1667V15.8334C30.6666 15.6565 30.5964 15.487 30.4714 15.362C30.3464 15.2369 30.1768 15.1667 30 15.1667ZM16.6666 27.1667H15.3333C15.1565 27.1667 14.9869 27.2369 14.8619 27.362C14.7369 27.487 14.6666 27.6565 14.6666 27.8334V30.5C14.6666 30.6768 14.7369 30.8464 14.8619 30.9714C14.9869 31.0965 15.1565 31.1667 15.3333 31.1667H16.6666C16.8435 31.1667 17.013 31.0965 17.1381 30.9714C17.2631 30.8464 17.3333 30.6768 17.3333 30.5V27.8334C17.3333 27.6565 17.2631 27.487 17.1381 27.362C17.013 27.2369 16.8435 27.1667 16.6666 27.1667ZM24.96 23.5667C24.8331 23.4437 24.6633 23.3749 24.4866 23.3749C24.3099 23.3749 24.1402 23.4437 24.0133 23.5667L23.0666 24.5C22.9436 24.6269 22.8749 24.7967 22.8749 24.9734C22.8749 25.1501 22.9436 25.3198 23.0666 25.4467L24.96 27.3267C25.0198 27.3905 25.0921 27.4413 25.1724 27.476C25.2526 27.5108 25.3392 27.5287 25.4266 27.5287C25.5141 27.5287 25.6006 27.5108 25.6809 27.476C25.7612 27.4413 25.8335 27.3905 25.8933 27.3267L26.84 26.38C26.9038 26.3202 26.9546 26.2479 26.9893 26.1676C27.0241 26.0874 27.042 26.0008 27.042 25.9134C27.042 25.8259 27.0241 25.7394 26.9893 25.6591C26.9546 25.5788 26.9038 25.5065 26.84 25.4467L24.96 23.5667Z" />
                          </svg>
                          <span className="block mt-2 font-medium">
                            {intl.formatMessage({ id: "innovation" })}
                          </span>
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="relative flex-1 sm-flex-none">
                    <div className="client-servey-custom-checkbox primary">
                      <input
                        type="checkbox"
                        id="communication-q5"
                        tabIndex={0}
                        name="value_5[]"
                        defaultValue="Communication"
                        onChange={handleQ5MattersCheckbox}
                        checked={
                          q5SelectedMatters.filter(
                            (obj) => obj === "Communication"
                          ).length > 0
                            ? true
                            : false
                        }
                      />
                      <label htmlFor="communication-q5">
                        <div className="client-servey-checkbox-px-4 client-servey-checkbox-py-5 sm-py-6">
                          <svg
                            className="w-8 h-8 mx-auto"
                            viewBox="0 0 32 32"
                            fill="currentColor"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M20.017 21.8067C22.9652 21.8067 25.3552 19.4223 25.3552 16.481V8.49237C25.3552 5.55106 22.9652 3.16665 20.017 3.16665H6.67156C3.72336 3.16665 1.33337 5.55106 1.33337 8.49237V25.1353C1.33337 25.5029 1.63212 25.801 2.00065 25.801C2.17696 25.8 2.3454 25.7279 2.46774 25.6013L5.13683 22.9384C5.9033 22.1939 6.93654 21.7863 8.00611 21.8067H20.017ZM28.0243 8.49237V19.1438C28.0243 22.0851 25.6343 24.4695 22.6861 24.4695H6.67156C6.67156 25.9402 7.86655 27.1324 9.34065 27.1324H24.0207C25.0868 27.1298 26.1099 27.5515 26.8632 28.3041L29.5323 30.9669C29.6547 31.0936 29.8231 31.1656 29.9994 31.1666C30.368 31.1666 30.6667 30.8686 30.6667 30.5009V11.1552C30.6668 9.69491 29.488 8.50698 28.0243 8.49237Z" />
                          </svg>
                          <span className="block mt-2 font-medium">
                            {intl.formatMessage({ id: "communication" })}
                          </span>
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="relative flex-1 sm-flex-none">
                    <div className="client-servey-custom-checkbox primary">
                      <input
                        type="checkbox"
                        id="flexibility-q5"
                        tabIndex={0}
                        name="value_5[]"
                        defaultValue="Flexibility and responsiveness"
                        onChange={handleQ5MattersCheckbox}
                        checked={
                          q5SelectedMatters.filter(
                            (obj) => obj === "Flexibility and responsiveness"
                          ).length > 0
                            ? true
                            : false
                        }
                      />
                      <label htmlFor="flexibility-q5">
                        <div className="client-servey-checkbox-px-4 client-servey-checkbox-py-5 sm-py-6">
                          <svg
                            className="w-8 h-8 mx-auto"
                            viewBox="0 0 32 32"
                            fill="currentColor"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M16 2.66665C8.63616 2.66665 2.66663 8.63619 2.66663 16C2.66663 23.3638 8.63616 29.3333 16 29.3333C23.3638 29.3333 29.3333 23.3638 29.3333 16C29.3333 12.4638 27.9285 9.07238 25.4281 6.57189C22.9276 4.07141 19.5362 2.66665 16 2.66665ZM22.0133 21.3333L21.3066 22.04C21.0429 22.2957 20.6237 22.2957 20.36 22.04L15.0266 16.7066C14.8964 16.5812 14.824 16.4074 14.8266 16.2266V8.66665C14.8266 8.29846 15.1251 7.99998 15.4933 7.99998H16.5066C16.8748 7.99998 17.1733 8.29846 17.1733 8.66665V15.52L22.0133 20.36C22.1444 20.488 22.2184 20.6634 22.2184 20.8466C22.2184 21.0299 22.1444 21.2053 22.0133 21.3333Z" />
                          </svg>
                          <span className="block mt-2 font-medium">
                            {intl.formatMessage({
                              id: "flexibility-and-responsiveness",
                            })}
                          </span>
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="relative flex-1 sm-flex-none">
                    <div className="client-servey-custom-checkbox primary">
                      <input
                        type="checkbox"
                        id="billing-q5"
                        tabIndex={0}
                        name="value_5[]"
                        defaultValue="Billing"
                        onChange={handleQ5MattersCheckbox}
                        checked={
                          q5SelectedMatters.filter((obj) => obj === "Billing")
                            .length > 0
                            ? true
                            : false
                        }
                      />
                      <label htmlFor="billing-q5">
                        <div className="client-servey-checkbox-px-4 client-servey-checkbox-py-5 sm-py-6">
                          <svg
                            className="w-8 h-8 mx-auto"
                            viewBox="0 0 32 32"
                            fill="currentColor"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M8.24004 29.6333C8.36041 29.7628 8.5299 29.8355 8.70671 29.8333H9.09337C9.27018 29.8355 9.43967 29.7628 9.56004 29.6333L12 27.1666C12.2638 26.9109 12.683 26.9109 12.9467 27.1666L15.36 29.58C15.4804 29.7095 15.6499 29.7821 15.8267 29.78H16.2134C16.3902 29.7821 16.5597 29.7095 16.68 29.58L19.0934 27.1666C19.3515 26.9358 19.7419 26.9358 20 27.1666L22.4134 29.58C22.5337 29.7095 22.7032 29.7821 22.88 29.78H23.2667C23.4435 29.7821 23.613 29.7095 23.7334 29.58L26.28 27.1666C26.5264 26.9183 26.6652 26.5831 26.6667 26.2333V4.49998C26.6667 3.7636 26.0698 3.16665 25.3334 3.16665H6.66671C5.93033 3.16665 5.33337 3.7636 5.33337 4.49998V26.18C5.33829 26.533 5.4764 26.8711 5.72004 27.1266L8.24004 29.6333ZM17.3334 18.5C17.3334 18.8682 17.0349 19.1666 16.6667 19.1666H11.3334C10.9652 19.1666 10.6667 18.8682 10.6667 18.5V17.1666C10.6667 16.7985 10.9652 16.5 11.3334 16.5H16.6667C17.0349 16.5 17.3334 16.7985 17.3334 17.1666V18.5ZM21.3334 13.1666C21.3334 13.5348 21.0349 13.8333 20.6667 13.8333H11.3334C10.9652 13.8333 10.6667 13.5348 10.6667 13.1666V11.8333C10.6667 11.4651 10.9652 11.1666 11.3334 11.1666H20.6667C21.0349 11.1666 21.3334 11.4651 21.3334 11.8333V13.1666Z" />
                          </svg>
                          <span className="block mt-2 font-medium">
                            {intl.formatMessage({ id: "billing" })}
                          </span>
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="relative flex-1 sm-flex-none">
                    <div className="client-servey-custom-checkbox primary">
                      <input
                        type="checkbox"
                        id="healthStandards-q5"
                        tabIndex={0}
                        name="value_5[]"
                        defaultValue="Health and Hygiene Standards"
                        onChange={handleQ5MattersCheckbox}
                        checked={
                          q5SelectedMatters.filter(
                            (obj) => obj === "Health and Hygiene Standards"
                          ).length > 0
                            ? true
                            : false
                        }
                      />
                      <label htmlFor="healthStandards-q5">
                        <div className="client-servey-checkbox-px-4 client-servey-checkbox-py-5 sm-py-6">
                          <svg
                            className="w-8 h-8 mx-auto"
                            viewBox="0 0 32 32"
                            fill="currentColor"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M28 5.33332C28 3.86056 26.8061 2.66665 25.3333 2.66665H9.33333C7.86057 2.66665 6.66667 3.86056 6.66667 5.33332H4.66667C4.29848 5.33332 4 5.63179 4 5.99998V7.33332C4 7.70151 4.29848 7.99998 4.66667 7.99998H6.66667V14.6666H4.66667C4.29848 14.6666 4 14.9651 4 15.3333V16.6666C4 17.0348 4.29848 17.3333 4.66667 17.3333H6.66667V24H4.66667C4.29848 24 4 24.2985 4 24.6666V26C4 26.3682 4.29848 26.6666 4.66667 26.6666H6.66667C6.66667 28.1394 7.86057 29.3333 9.33333 29.3333H25.3333C26.8061 29.3333 28 28.1394 28 26.6666V5.33332ZM18.9333 20.1066L17.8933 21.1066C17.5823 21.4116 17.0844 21.4116 16.7733 21.1066L15.7333 20.1066C14.5333 18.9333 12 16.6666 12 14.8533C12.0105 14.0859 12.3255 13.3542 12.8756 12.8191C13.4258 12.2839 14.166 11.9893 14.9333 12C15.8426 12.0256 16.705 12.4089 17.3333 13.0666C17.9616 12.4089 18.8241 12.0256 19.7333 12C20.5007 11.9893 21.2409 12.2839 21.791 12.8191C22.3411 13.3542 22.6561 14.0859 22.6667 14.8533C22.6667 16.6666 20.1333 18.9333 18.9333 20.1066Z" />
                          </svg>
                          <span className="block mt-2 font-medium">
                            {intl.formatMessage({
                              id: "health-and-hygiene-standards",
                            })}
                          </span>
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-span-2 lg:col-span-4">
                    <label
                      className="cust-servey-sr-only cust-servey-sr-only-label"
                      htmlFor="notes_value_5"
                    >
                      {intl.formatMessage({
                        id: "please-can-we-have-some-more-detail",
                      })}
                    </label>
                    <div className="mt-1">
                      <textarea
                        id="notes_value_5"
                        className="form-control form-control-client-servey "
                        rows={6}
                        placeholder={intl.formatMessage({
                          id: "please-can-we-have-some-more-detail",
                        })}
                        value={q5notes}
                        onChange={(e) => setq5notes(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <footer className="sticky inset-x-0 bottom-0 z-20 w-full py-6 mt-auto bg-white border-t border-gray-200">
              <div className="max-w-4xl px-4 mx-auto sm:px-6 lg:px-0 client-servey-less-padding">
                <div className="relative flex items-center justify-between">
                  <button
                    onClick={(e) => gotoPreviousStep(4)}
                    className="btn btn-gray btn-gray-client-servey client-survey-previous-btn"
                  >
                    {intl.formatMessage({ id: "previous" })}
                  </button>
                  <div className="absolute inset-0 py-2 -translate-x-1/2 left-half">
                    <nav
                      className="flex items-center justify-center"
                      aria-label="Progress"
                    >
                      <p className="text-sm font-medium">
                        {intl.formatMessage(
                          {
                            id: "step-of",
                          },
                          { step: 5, total: 7 }
                        )}
                      </p>
                      <ol className="items-center hidden ml-8 space-x-5 sm:flex">
                        <li>
                          <div className="relative flex items-center justify-center">
                            <span
                              className="absolute flex w-5 h-5 p-px"
                              aria-hidden="true"
                            >
                              <span className="w-full h-full rounded-full bg-rose-200" />
                            </span>
                            <span
                              className="relative block w-2.5 h-2.5 bg-rose-600 rounded-full"
                              aria-hidden="true"
                            />
                            <span className="sr-only">
                              {intl.formatMessage({ id: "step" }, { step: 1 })}
                            </span>
                          </div>
                        </li>
                        <li>
                          <div className="block w-2.5 h-2.5 rounded-full bg-rose-600">
                            <span
                              className="absolute flex w-5 h-5 p-px"
                              aria-hidden="true"
                            >
                              <span className="w-full h-full rounded-full bg-rose-200" />
                            </span>
                            <span
                              className="relative block w-2.5 h-2.5 bg-rose-600 rounded-full"
                              aria-hidden="true"
                            />
                            <span className="sr-only">
                              {intl.formatMessage({ id: "step" }, { step: 2 })}
                            </span>
                          </div>
                        </li>
                        <li>
                          <div className="block w-2.5 h-2.5 rounded-full bg-rose-600">
                            <span
                              className="absolute flex w-5 h-5 p-px"
                              aria-hidden="true"
                            >
                              <span className="w-full h-full rounded-full bg-rose-200" />
                            </span>
                            <span className="sr-only">
                              {intl.formatMessage({ id: "step" }, { step: 3 })}
                            </span>
                          </div>
                        </li>
                        <li>
                          <div className="block w-2.5 h-2.5 rounded-full bg-rose-600">
                            <span
                              className="absolute flex w-5 h-5 p-px"
                              aria-hidden="true"
                            >
                              <span className="w-full h-full rounded-full bg-rose-200" />
                            </span>
                            <span className="sr-only">
                              {intl.formatMessage({ id: "step" }, { step: 4 })}
                            </span>
                          </div>
                        </li>
                        <li>
                          <div
                            className="block w-2.5 h-2.5 rounded-full bg-rose-600"
                            aria-current="step"
                          >
                            <div
                              className="relative flex items-center justify-center"
                              aria-current="step"
                            >
                              <span
                                className="absolute flex w-5 h-5 p-px curntStepHighlight"
                                aria-hidden="true"
                              >
                                <span className="w-full h-full rounded-full bg-rose-200" />
                              </span>
                              <span
                                className="relative block w-2.5 h-2.5 bg-rose-600 rounded-full"
                                aria-hidden="true"
                              />
                              <span className="sr-only">
                                {intl.formatMessage(
                                  { id: "step" },
                                  { step: 5 }
                                )}
                              </span>
                            </div>
                          </div>
                        </li>
                        <li>
                          <div className="block w-2.5 h-2.5 bg-gray-200 rounded-full hover:bg-gray-400">
                            <span className="sr-only">
                              {intl.formatMessage({ id: "step" }, { step: 6 })}
                            </span>
                          </div>
                        </li>
                        <li>
                          <div className="block w-2.5 h-2.5 bg-gray-200 rounded-full hover:bg-gray-400">
                            <span className="sr-only">
                              {intl.formatMessage({ id: "step" }, { step: 7 })}
                            </span>
                          </div>
                        </li>
                      </ol>
                    </nav>
                  </div>
                  <button
                    onClick={(e) => goToStep6Block(e)}
                    className="btn btn-primary client-survey-btn client-survey-next-btn"
                  >
                    {intl.formatMessage({ id: "next" })}
                  </button>
                </div>
              </div>
            </footer>
          </div>
        ) : isShowStep6Block === true ? (
          <div>
            <section className="w-full py-12 bg-white">
              <div className="max-w-4xl px-4 mx-auto sm:px-6 lg:px-0">
                <h1 className="text-2xl font-semibold text-center sm:text-3xl lg:text-4xl client-servey-question-font-size">
                  {intl.formatMessage({
                    id: "to-help-us-understand-your-csr-priorities-please-order-in-rank-of-importance-the-following",
                  })}
                </h1>
              </div>
              <div className="max-w-4xl px-4 mx-auto sm:px-6 lg:px-0">
                <div className="grid grid-cols-3 mt-12 text-center gap-x-6 lg:gap-x-12">
                  <div>
                    <p className="text-lg font-semibold">
                      {intl.formatMessage({ id: "sustainable-ingredients" })}
                    </p>
                    <div className="mt-5 space-y-6">
                      <div className="relative flex-1 sm:flex-none">
                        <div className="client-servey-custom-checkbox-landscape green">
                          {q6Order1 > 0 ? (
                            <div className="client-servey-custom-checkbox-count hide foodWaste-hide ">
                              <div className="client-servey-count-order foodWaste">
                                {" "}
                                {q6Order1}
                              </div>
                            </div>
                          ) : (
                            ""
                          )}

                          <input
                            type="checkbox"
                            id="foodWaste"
                            tabIndex={0}
                            name="value_6[]"
                            defaultValue="Food Waste"
                            onChange={(e) => handleQ6MattersCheckbox(e, 1)}
                            checked={
                              q6SelectedMatters.filter(
                                (obj) => obj === "Food Waste"
                              ).length > 0
                                ? true
                                : false
                            }
                          />
                          <label htmlFor="foodWaste">
                            <div className="client-servey-checkbox-px-4 client-servey-checkbox-py-5 sm-py-6">
                              <svg
                                className="w-8 h-8 mx-auto"
                                viewBox="0 0 32 32"
                                fill="currentColor"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path d="M26.6666 6.5V7.83333C26.6666 8.20152 26.3681 8.5 25.9999 8.5H5.99992C5.63173 8.5 5.33325 8.20152 5.33325 7.83333V6.5C5.33325 6.13181 5.63173 5.83333 5.99992 5.83333H11.9999V4.5C11.9999 3.76362 12.5969 3.16667 13.3333 3.16667H18.6666C19.403 3.16667 19.9999 3.76362 19.9999 4.5V5.83333H25.9999C26.3681 5.83333 26.6666 6.13181 26.6666 6.5ZM7.82659 27.3533C7.92478 28.7527 9.09041 29.8368 10.4933 29.8333H21.5333C22.9361 29.8368 24.1017 28.7527 24.1999 27.3533L25.3333 11.1667H6.66659L7.82659 27.3533Z" />
                              </svg>
                              <span className="block mt-2 font-medium">
                                {intl.formatMessage({ id: "food-waste" })}
                              </span>
                            </div>
                          </label>
                        </div>
                      </div>
                      <div className="relative flex-1 sm:flex-none">
                        <div className="client-servey-custom-checkbox-landscape green">
                          {q6Order2 > 0 ? (
                            <div className="client-servey-custom-checkbox-count hide localSourcing-hide ">
                              <div className="client-servey-count-order localSourcing">
                                {q6Order2}
                              </div>
                            </div>
                          ) : (
                            ""
                          )}

                          <input
                            type="checkbox"
                            id="localSourcing"
                            tabIndex={0}
                            name="value_6[]"
                            defaultValue="Local Sourcing"
                            onChange={(e) => handleQ6MattersCheckbox(e, 2)}
                            checked={
                              q6SelectedMatters.filter(
                                (obj) => obj === "Local Sourcing"
                              ).length > 0
                                ? true
                                : false
                            }
                          />
                          <label htmlFor="localSourcing">
                            <div className="client-servey-checkbox-px-4 client-servey-checkbox-py-5 sm-py-6">
                              <svg
                                className="w-8 h-8 mx-auto"
                                viewBox="0 0 32 32"
                                fill="currentColor"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path d="M27.64 9.99333L27.4533 9.66C27.2126 9.25691 26.873 8.92191 26.4667 8.68666L17.52 3.52666C17.1149 3.29166 16.655 3.1675 16.1867 3.16666H15.8C15.3317 3.1675 14.8718 3.29166 14.4667 3.52666L5.52 8.7C5.11597 8.93367 4.78034 9.2693 4.54667 9.67333L4.36 10.0067C4.125 10.4118 4.00083 10.8717 4 11.34V21.6733C4.00083 22.1417 4.125 22.6015 4.36 23.0067L4.54667 23.34C4.78639 23.7393 5.12065 24.0736 5.52 24.3133L14.48 29.4733C14.8831 29.7132 15.3443 29.8377 15.8133 29.8333H16.1867C16.655 29.8325 17.1149 29.7083 17.52 29.4733L26.4667 24.3C26.8747 24.0716 27.2116 23.7347 27.44 23.3267L27.64 22.9933C27.8722 22.587 27.9961 22.1279 28 21.66V11.3267C27.9992 10.8583 27.875 10.3985 27.64 9.99333ZM15.8 5.83333H16.1867L24 10.34L16 14.9533L8 10.34L15.8 5.83333ZM25.1333 21.9933L17.3333 26.5V17.2733L25.3333 12.6467V21.66L25.1333 21.9933Z" />
                              </svg>
                              <span className="block mt-2 font-medium">
                                {intl.formatMessage({ id: "local-sourcing" })}
                              </span>
                            </div>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <p className="text-lg font-semibold">
                      {intl.formatMessage({ id: "people-and-communities" })}
                    </p>
                    <div className="mt-5 space-y-6">
                      <div className="relative flex-1 sm:flex-none">
                        <div className="client-servey-custom-checkbox-landscape green">
                          {q6Order3 > 0 ? (
                            <div className="client-servey-custom-checkbox-count hide energyReduction-hide ">
                              <div className="client-servey-count-order energyReduction">
                                {q6Order3}
                              </div>
                            </div>
                          ) : (
                            ""
                          )}

                          <input
                            type="checkbox"
                            id="energyReduction"
                            tabIndex={0}
                            name="value_6[]"
                            defaultValue="Energy Reducation"
                            onChange={(e) => handleQ6MattersCheckbox(e, 3)}
                            checked={
                              q6SelectedMatters.filter(
                                (obj) => obj === "Energy Reducation"
                              ).length > 0
                                ? true
                                : false
                            }
                          />
                          <label htmlFor="energyReduction">
                            <div className="client-servey-checkbox-px-4 client-servey-checkbox-py-5 sm-py-6">
                              <svg
                                className="w-8 h-8 mx-auto"
                                viewBox="0 0 32 32"
                                fill="currentColor"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path d="M26.6666 11.8333V13.1667C26.6666 13.5349 26.3681 13.8333 25.9999 13.8333H25.3333V16.9533C25.3344 18.3682 24.7732 19.7256 23.7733 20.7267L21.1733 23.3933C20.494 24.0458 19.6064 24.4377 18.6666 24.5V29.1667C18.6666 29.5349 18.3681 29.8333 17.9999 29.8333H13.9999C13.6317 29.8333 13.3333 29.5349 13.3333 29.1667V24.5C12.3882 24.4268 11.4999 24.0205 10.8266 23.3533L8.22659 20.6867C7.2364 19.6954 6.67602 18.3544 6.66659 16.9533V13.8333H5.99992C5.63173 13.8333 5.33325 13.5349 5.33325 13.1667V11.8333C5.33325 11.4651 5.63173 11.1667 5.99992 11.1667H9.33325V3.83333C9.33325 3.46514 9.63173 3.16667 9.99992 3.16667H11.3333C11.7014 3.16667 11.9999 3.46514 11.9999 3.83333V11.1667H19.9999V3.83333C19.9999 3.46514 20.2984 3.16667 20.6666 3.16667H21.9999C22.3681 3.16667 22.6666 3.46514 22.6666 3.83333V11.1667H25.9999C26.3681 11.1667 26.6666 11.4651 26.6666 11.8333Z" />
                              </svg>
                              <span className="block mt-2 font-medium">
                                {intl.formatMessage({ id: "energy-reduction" })}
                              </span>
                            </div>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="mt-2 space-y-6">
                      <div className="relative flex-1 sm:flex-none">
                        {/* <label htmlFor="workingWithLocalCommunities" className="sr-only">
                                        Local Sourcing
                                        </label> */}
                        <div className="client-servey-custom-checkbox-landscape green">
                          {q6Order4 > 0 ? (
                            <div className="client-servey-custom-checkbox-count hide workingWithLocalCommunities-hide ">
                              <div className="client-servey-count-order workingWithLocalCommunities">
                                {q6Order4}
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                          <input
                            type="checkbox"
                            id="workingWithLocalCommunities"
                            tabIndex={0}
                            name="value_6[]"
                            defaultValue="Working with local communities"
                            onChange={(e) => handleQ6MattersCheckbox(e, 4)}
                            checked={
                              q6SelectedMatters.filter(
                                (obj) =>
                                  obj === "Working with local communities"
                              ).length > 0
                                ? true
                                : false
                            }
                          />
                          <label htmlFor="workingWithLocalCommunities">
                            <div className="client-servey-checkbox-px-4 client-servey-checkbox-py-5 sm-py-6">
                              <svg
                                className="w-8 h-8 mx-auto"
                                viewBox="0 0 32 32"
                                fill="currentColor"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path d="M6.66817 10.6666C6.66817 8.4575 8.45952 6.66664 10.6693 6.66664C12.879 6.66664 14.6704 8.4575 14.6704 10.6666C14.6704 12.8758 12.879 14.6666 10.6693 14.6666C8.45952 14.6666 6.66817 12.8758 6.66817 10.6666ZM21.3389 14.6666C23.5486 14.6666 25.34 12.8758 25.34 10.6666C25.34 8.4575 23.5486 6.66664 21.3389 6.66664C19.1291 6.66664 17.3378 8.4575 17.3378 10.6666C17.3378 12.8758 19.1291 14.6666 21.3389 14.6666ZM30.5281 23.4L28.6075 19.5466C27.9311 18.1921 26.5476 17.3354 25.0332 17.3333H19.6984C19.9425 17.6507 20.1568 17.9899 20.3386 18.3466L22.2725 22.2133C22.751 23.1868 22.8136 24.3128 22.4458 25.3333H29.3411C29.8033 25.3319 30.2319 25.0913 30.4737 24.6975C30.7155 24.3036 30.7361 23.8127 30.5281 23.4ZM17.9379 19.5466C17.2593 18.1878 15.8695 17.3303 14.3503 17.3333H6.98826C5.46904 17.3303 4.07919 18.1878 3.4006 19.5466L1.48007 23.4C1.27206 23.8127 1.29263 24.3036 1.53444 24.6975C1.77625 25.0913 2.20482 25.3319 2.66707 25.3333H18.6715C19.1337 25.3319 19.5623 25.0913 19.8041 24.6975C20.0459 24.3036 20.0665 23.8127 19.8585 23.4L17.9379 19.5466Z" />
                              </svg>
                              <span className="block mt-2 font-medium">
                                {intl.formatMessage({
                                  id: "working-with-local-communities",
                                })}
                              </span>
                            </div>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <p className="text-lg font-semibold">
                      {intl.formatMessage({ id: "environmental-choices" })}
                    </p>
                    <div className="mt-5 space-y-6">
                      <div className="relative flex-1 sm:flex-none">
                        {/* <label htmlFor="meatFree" className="sr-only">
                                        Meat Free
                                        </label> */}
                        <div className="client-servey-custom-checkbox-landscape green">
                          {q6Order5 > 0 ? (
                            <div className="client-servey-custom-checkbox-count hide meatFree-hide ">
                              <div className="client-servey-count-order meatFree">
                                {q6Order5}
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                          <input
                            type="checkbox"
                            id="meatFree"
                            tabIndex={0}
                            name="value_6[]"
                            defaultValue="Meal Free"
                            onChange={(e) => handleQ6MattersCheckbox(e, 5)}
                            checked={
                              q6SelectedMatters.filter(
                                (obj) => obj === "Meal Free"
                              ).length > 0
                                ? true
                                : false
                            }
                          />
                          <label htmlFor="meatFree">
                            <div className="client-servey-checkbox-px-4 client-servey-checkbox-py-5 sm-py-6">
                              <svg
                                className="w-8 h-8 mx-auto"
                                viewBox="0 0 32 32"
                                fill="currentColor"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path d="M4 15.1667C4 12.3377 5.12381 9.62458 7.12419 7.62419C9.12458 5.62381 11.8377 4.5 14.6667 4.5H17.3333C20.1623 4.5 22.8754 5.62381 24.8758 7.62419C26.8762 9.62458 28 12.3377 28 15.1667C28 15.5203 27.8595 15.8594 27.6095 16.1095C27.3594 16.3595 27.0203 16.5 26.6667 16.5H5.33333C4.97971 16.5 4.64057 16.3595 4.39052 16.1095C4.14048 15.8594 4 15.5203 4 15.1667ZM26.6667 24.5H24.4C24.0502 24.5015 23.715 24.6403 23.4667 24.8867L21.3333 26.9667C21.2714 27.0292 21.1976 27.0787 21.1164 27.1126C21.0351 27.1464 20.948 27.1639 20.86 27.1639C20.772 27.1639 20.6849 27.1464 20.6036 27.1126C20.5224 27.0787 20.4486 27.0292 20.3867 26.9667L18.3067 24.8867C18.0583 24.6403 17.7231 24.5015 17.3733 24.5H5.33333C4.97971 24.5 4.64057 24.6405 4.39052 24.8905C4.14048 25.1406 4 25.4797 4 25.8333V27.1667C4 27.5203 4.14048 27.8594 4.39052 28.1095C4.64057 28.3595 4.97971 28.5 5.33333 28.5H26.6667C27.0203 28.5 27.3594 28.3595 27.6095 28.1095C27.8595 27.8594 28 27.5203 28 27.1667V25.8333C28 25.4797 27.8595 25.1406 27.6095 24.8905C27.3594 24.6405 27.0203 24.5 26.6667 24.5ZM26.6667 19.1667H15.0667C14.7169 19.1681 14.3817 19.307 14.1333 19.5533L12 21.6333C11.938 21.6958 11.8643 21.7454 11.7831 21.7793C11.7018 21.8131 11.6147 21.8305 11.5267 21.8305C11.4387 21.8305 11.3515 21.8131 11.2703 21.7793C11.189 21.7454 11.1153 21.6958 11.0533 21.6333L9.02667 19.5533C8.77832 19.307 8.44312 19.1681 8.09333 19.1667H5.33333C4.97971 19.1667 4.64057 19.3071 4.39052 19.5572C4.14048 19.8072 4 20.1464 4 20.5V21.8333C4 22.187 4.14048 22.5261 4.39052 22.7761C4.64057 23.0262 4.97971 23.1667 5.33333 23.1667H26.6667C27.0203 23.1667 27.3594 23.0262 27.6095 22.7761C27.8595 22.5261 28 22.187 28 21.8333V20.5C28 20.1464 27.8595 19.8072 27.6095 19.5572C27.3594 19.3071 27.0203 19.1667 26.6667 19.1667Z" />
                              </svg>
                              <span className="block mt-2 font-medium">
                                {intl.formatMessage({ id: "meat-free" })}
                              </span>
                            </div>
                          </label>
                        </div>
                      </div>
                      <div className="relative flex-1 sm:flex-none">
                        {/* <label htmlFor="lessPlastic" className="sr-only">
                                    Local Sourcing
                                    </label> */}
                        <div className="client-servey-custom-checkbox-landscape green">
                          {q6Order6 > 0 ? (
                            <div className="client-servey-custom-checkbox-count hide lessPlastic-hide ">
                              <div className="client-servey-count-order lessPlastic">
                                {q6Order6}
                              </div>
                            </div>
                          ) : (
                            ""
                          )}

                          <input
                            type="checkbox"
                            id="lessPlastic"
                            tabIndex={0}
                            name="value_6[]"
                            defaultValue="Less Plastic"
                            onChange={(e) => handleQ6MattersCheckbox(e, 6)}
                            checked={
                              q6SelectedMatters.filter(
                                (obj) => obj === "Less Plastic"
                              ).length > 0
                                ? true
                                : false
                            }
                          />
                          <label htmlFor="lessPlastic">
                            <div className="client-servey-checkbox-px-4 client-servey-checkbox-py-5 sm-py-6">
                              <svg
                                className="w-8 h-8 mx-auto"
                                viewBox="0 0 32 32"
                                fill="currentColor"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path d="M16 8.60667L14.4667 11.2733C14.3751 11.4256 14.2275 11.536 14.0556 11.5808C13.8836 11.6257 13.701 11.6015 13.5467 11.5133L11.24 10.18C11.0886 10.0909 10.9785 9.94577 10.9336 9.77601C10.8887 9.60624 10.9125 9.42561 11 9.27333L13 5.83333C13.2338 5.42835 13.57 5.09197 13.9749 4.85795C14.3797 4.62392 14.839 4.50048 15.3067 4.5H16.64C17.1076 4.50048 17.5669 4.62392 17.9718 4.85795C18.3766 5.09197 18.7128 5.42835 18.9467 5.83333L21.3333 9.68667L22.9333 8.74C23.0959 8.67473 23.2774 8.67473 23.44 8.74L23.76 8.82C23.8303 8.84687 23.8908 8.89435 23.9336 8.95621C23.9764 9.01807 23.9996 9.09143 24 9.16667L22.5333 14.7933C22.4864 14.966 22.3733 15.1132 22.2186 15.2031C22.0638 15.293 21.8799 15.3182 21.7067 15.2733L16 13.8333C15.9153 13.8031 15.8444 13.7432 15.8003 13.6648C15.7562 13.5864 15.7419 13.4948 15.76 13.4067L15.8533 13.1C15.8707 13.0145 15.9058 12.9335 15.9563 12.8624C16.0069 12.7912 16.0717 12.7313 16.1467 12.6867L17.76 11.74L16 8.60667ZM27.6267 20.6067L25.6533 17.1667C25.5643 17.0153 25.4191 16.9052 25.2493 16.8603C25.0796 16.8153 24.8989 16.8392 24.7467 16.9267L22.44 18.26C22.3637 18.3028 22.2968 18.3605 22.2432 18.4296C22.1897 18.4988 22.1505 18.578 22.1282 18.6626C22.1058 18.7471 22.1006 18.8353 22.1129 18.9219C22.1253 19.0085 22.1549 19.0917 22.2 19.1667L23.7467 21.8333H20V19.9667C19.9985 19.8784 19.9789 19.7913 19.9421 19.711C19.9054 19.6307 19.8525 19.5589 19.7867 19.5L19.56 19.26C19.494 19.201 19.4085 19.1683 19.32 19.1683C19.2314 19.1683 19.146 19.201 19.08 19.26L14.9733 23.3667C14.9095 23.4265 14.8587 23.4988 14.824 23.5791C14.7892 23.6593 14.7713 23.7459 14.7713 23.8333C14.7713 23.9208 14.7892 24.0073 14.824 24.0876C14.8587 24.1679 14.9095 24.2401 14.9733 24.3L19.08 28.4067C19.146 28.4657 19.2314 28.4983 19.32 28.4983C19.4085 28.4983 19.494 28.4657 19.56 28.4067L19.7867 28.1667C19.8525 28.1078 19.9054 28.036 19.9421 27.9556C19.9789 27.8753 19.9985 27.7883 20 27.7V25.8333H24.64C25.1054 25.8305 25.5619 25.706 25.9642 25.4721C26.3665 25.2382 26.7006 24.903 26.9333 24.5L27.64 23.2467C27.8872 22.8307 28.0165 22.3553 28.0142 21.8715C28.0118 21.3876 27.8779 20.9135 27.6267 20.5V20.6067ZM11.2933 13.6333C11.2716 13.5483 11.2333 13.4685 11.1806 13.3983C11.1279 13.3281 11.0619 13.2691 10.9863 13.2245C10.9107 13.1799 10.8271 13.1506 10.7402 13.1384C10.6534 13.1262 10.5649 13.1313 10.48 13.1533L4.85332 14.6333C4.76792 14.6583 4.69538 14.7151 4.6507 14.792C4.60603 14.869 4.59265 14.9601 4.61332 15.0467L4.70666 15.3533C4.72478 15.4403 4.76159 15.5224 4.81454 15.5937C4.86749 15.6651 4.93531 15.7241 5.01332 15.7667L6.66666 16.7133L4.39999 20.58C4.16594 20.9854 4.04272 21.4452 4.04272 21.9133C4.04272 22.3814 4.16594 22.8413 4.39999 23.2467L5.09332 24.46C5.32939 24.8689 5.66979 25.2078 6.07975 25.4421C6.4897 25.6763 6.95451 25.7976 7.42666 25.7933H11.4267C11.6035 25.7933 11.773 25.7231 11.8981 25.5981C12.0231 25.473 12.0933 25.3035 12.0933 25.1267V22.46C12.0933 22.2832 12.0231 22.1136 11.8981 21.9886C11.773 21.8636 11.6035 21.7933 11.4267 21.7933H8.26666L10.08 18.7L11.6933 19.6333C11.7729 19.6694 11.8593 19.6881 11.9467 19.6881C12.034 19.6881 12.1204 19.6694 12.2 19.6333L12.52 19.5533C12.6036 19.5257 12.6743 19.4684 12.7185 19.3922C12.7627 19.3161 12.7775 19.2263 12.76 19.14L11.2933 13.6333Z" />
                              </svg>
                              <span className="block mt-2 font-medium">
                                {intl.formatMessage({ id: "less-plastic" })}
                              </span>
                            </div>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <footer className="sticky inset-x-0 bottom-0 z-20 w-full py-6 mt-auto bg-white border-t border-gray-200">
              <div className="max-w-4xl px-4 mx-auto sm:px-6 lg:px-0 client-servey-less-padding">
                <div className="relative flex items-center justify-between">
                  <button
                    onClick={(e) => gotoPreviousStep(5)}
                    className="btn btn-gray btn-gray-client-servey client-survey-previous-btn"
                  >
                    {intl.formatMessage({ id: "previous" })}
                  </button>
                  <div className="absolute inset-0 py-2 -translate-x-1/2 left-half">
                    <nav
                      className="flex items-center justify-center"
                      aria-label="Progress"
                    >
                      <p className="text-sm font-medium">
                        {intl.formatMessage(
                          { id: "step-of" },
                          { step: 6, total: 7 }
                        )}
                      </p>
                      <ol className="items-center hidden ml-8 space-x-5 sm:flex">
                        <li>
                          <div className="relative flex items-center justify-center">
                            <span
                              className="absolute flex w-5 h-5 p-px"
                              aria-hidden="true"
                            >
                              <span className="w-full h-full rounded-full bg-rose-200" />
                            </span>
                            <span
                              className="relative block w-2.5 h-2.5 bg-rose-600 rounded-full"
                              aria-hidden="true"
                            />
                            <span className="sr-only">
                              {intl.formatMessage({ id: "step" }, { step: 1 })}
                            </span>
                          </div>
                        </li>
                        <li>
                          <div className="block w-2.5 h-2.5 rounded-full bg-rose-600">
                            <span
                              className="absolute flex w-5 h-5 p-px"
                              aria-hidden="true"
                            >
                              <span className="w-full h-full rounded-full bg-rose-200" />
                            </span>
                            <span
                              className="relative block w-2.5 h-2.5 bg-rose-600 rounded-full"
                              aria-hidden="true"
                            />
                            <span className="sr-only">
                              {intl.formatMessage({ id: "step" }, { step: 2 })}
                            </span>
                          </div>
                        </li>
                        <li>
                          <div className="block w-2.5 h-2.5 rounded-full bg-rose-600">
                            <span
                              className="absolute flex w-5 h-5 p-px"
                              aria-hidden="true"
                            >
                              <span className="w-full h-full rounded-full bg-rose-200" />
                            </span>
                            <span className="sr-only">
                              {intl.formatMessage({ id: "step" }, { step: 3 })}
                            </span>
                          </div>
                        </li>
                        <li>
                          <div className="block w-2.5 h-2.5 rounded-full bg-rose-600">
                            <span
                              className="absolute flex w-5 h-5 p-px"
                              aria-hidden="true"
                            >
                              <span className="w-full h-full rounded-full bg-rose-200" />
                            </span>
                            <span className="sr-only">
                              {intl.formatMessage({ id: "step" }, { step: 4 })}
                            </span>
                          </div>
                        </li>
                        <li>
                          <div className="block w-2.5 h-2.5 rounded-full bg-rose-600">
                            <span
                              className="absolute flex w-5 h-5 p-px"
                              aria-hidden="true"
                            >
                              <span className="w-full h-full rounded-full bg-rose-200" />
                            </span>
                            <span className="sr-only">
                              {intl.formatMessage({ id: "step" }, { step: 5 })}
                            </span>
                          </div>
                        </li>
                        <li>
                          <div
                            className="relative flex items-center justify-center"
                            aria-current="step"
                          >
                            <span
                              className="absolute flex w-5 h-5 p-px curntStepHighlight"
                              aria-hidden="true"
                            >
                              <span className="w-full h-full rounded-full bg-rose-200" />
                            </span>
                            <span
                              className="relative block w-2.5 h-2.5 bg-rose-600 rounded-full"
                              aria-hidden="true"
                            />
                            <span className="sr-only">
                              {intl.formatMessage({ id: "step" }, { step: 6 })}
                            </span>
                          </div>
                        </li>
                        <li>
                          <div className="block w-2.5 h-2.5 bg-gray-200 rounded-full hover:bg-gray-400">
                            <span className="sr-only">
                              {intl.formatMessage({ id: "step" }, { step: 7 })}
                            </span>
                          </div>
                        </li>
                      </ol>
                    </nav>
                  </div>
                  <button
                    onClick={(e) => goToStep7Block(e)}
                    className="btn btn-primary client-survey-btn client-survey-next-btn"
                  >
                    {intl.formatMessage({ id: "next" })}
                  </button>
                </div>
              </div>
            </footer>
          </div>
        ) : isShowStep7Block === true ? (
          <div>
            <section className="w-full py-12 bg-white">
              <div className="max-w-4xl px-4 mx-auto sm:px-6 lg:px-0">
                <h1 className="max-w-2xl mx-auto text-2xl font-semibold text-center sm:text-3xl lg:text-4xl client-servey-question-font-size">
                  {intl.formatMessage({
                    id: "would-you-like-to-be-contacted-about-your-feedback",
                  })}
                </h1>
                <form
                  method="POST"
                  className="max-w-3xl mx-auto mt-12"
                  autoComplete="off"
                >
                  <div className="grid grid-cols-2 gap-x-5 gap-y-4">
                    <div>
                      <label className="form-input-label">
                        {intl.formatMessage({ id: "full-name" })}
                      </label>
                      <div className="mt-1">
                        <input
                          type="text"
                          id="contact_name"
                          name="contact_name"
                          value={contact_name}
                          onChange={(e) => set_contact_name(e.target.value)}
                          className="form-control form-control-client-servey"
                        />
                      </div>
                    </div>
                    <div>
                      <label className="form-input-label">
                        {intl.formatMessage({ id: "email-address" })}
                      </label>
                      <div className="mt-1">
                        <input
                          type="text"
                          id="contact_email"
                          name="contact_email"
                          className="form-control form-control-client-servey"
                          value={contact_email}
                          onChange={(e) => set_contact_email(e.target.value)}
                          autoComplete="off"
                        />
                        <span style={{ color: "red" }}>
                          {emailError !== "" ? emailError : ""}
                        </span>
                      </div>
                    </div>
                    <div className="col-span-2">
                      <label className="form-input-label">
                        {intl.formatMessage({ id: "phone-number" })}
                      </label>
                      <div className="mt-1">
                        <input
                          type="text"
                          id="contact_phone"
                          name="contact_phone"
                          className="form-control form-control-client-servey"
                          value={contact_phone}
                          onKeyPress={(event) => {
                            if (!/[0-9]/.test(event.key)) {
                              event.preventDefault();
                            }
                          }}
                          onChange={(e) => set_contact_phone(e.target.value)}
                          autoComplete="off"
                        />
                        <span style={{ color: "red" }}>
                          {phoneError !== "" ? phoneError : ""}
                        </span>
                      </div>
                    </div>
                    <div className="col-span-2">
                      <label className="form-input-label">
                        {intl.formatMessage({ id: "feedback" })}
                      </label>
                      <div className="mt-1">
                        <textarea
                          id="contact_feedback"
                          rows={4}
                          className="form-control form-control-client-servey resize-y"
                          value={contact_feedback}
                          onChange={(e) => set_contact_feedback(e.target.value)}
                          autoComplete="off"
                        />
                      </div>
                    </div>
                    <div className="col-span-2">
                      <Link
                        to="/404-not-found"
                        className="text-sm font-medium underline transition-all duration-200 hover:text-rose-600"
                        style={{ textDecoration: "underline" }}
                      >
                        {intl.formatMessage({ id: "view-our-privacy-policy" })}
                      </Link>
                    </div>
                  </div>
                </form>
              </div>
            </section>

            <footer className="sticky inset-x-0 bottom-0 z-20 w-full py-6 mt-auto bg-white border-t border-gray-200">
              <div className="max-w-4xl px-4 mx-auto sm:px-6 lg:px-0 client-servey-less-padding">
                <div className="relative flex items-center justify-between">
                  <button
                    onClick={(e) => gotoPreviousStep(6)}
                    className="btn btn-gray btn-gray-client-servey client-survey-previous-btn"
                  >
                    {intl.formatMessage({ id: "previous" })}
                  </button>
                  <div className="absolute inset-0 py-2 -translate-x-1/2 left-half">
                    <nav
                      className="flex items-center justify-center"
                      aria-label="Progress"
                    >
                      <p className="text-sm font-medium">
                        {intl.formatMessage(
                          { id: "step-of" },
                          { step: 7, total: 7 }
                        )}
                      </p>
                      <ol className="items-center hidden ml-8 space-x-5 sm:flex">
                        <li>
                          <div className="relative flex items-center justify-center">
                            <span
                              className="absolute flex w-5 h-5 p-px"
                              aria-hidden="true"
                            >
                              <span className="w-full h-full rounded-full bg-rose-200" />
                            </span>
                            <span
                              className="relative block w-2.5 h-2.5 bg-rose-600 rounded-full"
                              aria-hidden="true"
                            />
                            <span className="sr-only">
                              {intl.formatMessage({ id: "step" }, { step: 1 })}
                            </span>
                          </div>
                        </li>
                        <li>
                          <div className="block w-2.5 h-2.5 rounded-full bg-rose-600">
                            <span
                              className="absolute flex w-5 h-5 p-px"
                              aria-hidden="true"
                            >
                              <span className="w-full h-full rounded-full bg-rose-200" />
                            </span>
                            <span
                              className="relative block w-2.5 h-2.5 bg-rose-600 rounded-full"
                              aria-hidden="true"
                            />
                            <span className="sr-only">
                              {intl.formatMessage({ id: "step" }, { step: 2 })}
                            </span>
                          </div>
                        </li>
                        <li>
                          <div className="block w-2.5 h-2.5 rounded-full bg-rose-600">
                            <span
                              className="absolute flex w-5 h-5 p-px"
                              aria-hidden="true"
                            >
                              <span className="w-full h-full rounded-full bg-rose-200" />
                            </span>
                            <span className="sr-only">
                              {intl.formatMessage({ id: "step" }, { step: 3 })}
                            </span>
                          </div>
                        </li>
                        <li>
                          <div className="block w-2.5 h-2.5 rounded-full bg-rose-600">
                            <span
                              className="absolute flex w-5 h-5 p-px"
                              aria-hidden="true"
                            >
                              <span className="w-full h-full rounded-full bg-rose-200" />
                            </span>
                            <span className="sr-only">
                              {intl.formatMessage({ id: "step" }, { step: 4 })}
                            </span>
                          </div>
                        </li>
                        <li>
                          <div className="block w-2.5 h-2.5 rounded-full bg-rose-600">
                            <span
                              className="absolute flex w-5 h-5 p-px"
                              aria-hidden="true"
                            >
                              <span className="w-full h-full rounded-full bg-rose-200" />
                            </span>
                            <span className="sr-only">
                              {intl.formatMessage({ id: "step" }, { step: 5 })}
                            </span>
                          </div>
                        </li>
                        <li>
                          <div className="block w-2.5 h-2.5 rounded-full bg-rose-600">
                            <span
                              className="absolute flex w-5 h-5 p-px"
                              aria-hidden="true"
                            >
                              <span className="w-full h-full rounded-full bg-rose-200" />
                            </span>
                            <span className="sr-only">
                              {intl.formatMessage({ id: "step" }, { step: 6 })}
                            </span>
                          </div>
                        </li>
                        <li>
                          <div
                            className="relative flex items-center justify-center"
                            aria-current="step"
                          >
                            <span
                              className="absolute flex w-5 h-5 p-px curntStepHighlight"
                              aria-hidden="true"
                            >
                              <span className="w-full h-full rounded-full bg-rose-200" />
                            </span>
                            <span
                              className="relative block w-2.5 h-2.5 bg-rose-600 rounded-full"
                              aria-hidden="true"
                            />
                            <span className="sr-only">
                              {intl.formatMessage({ id: "step" }, { step: 7 })}
                            </span>
                          </div>
                        </li>
                      </ol>
                    </nav>
                  </div>
                  <button
                    onClick={(e) => goToTankyou(e)}
                    className="btn btn-primary client-survey-btn client-survey-finish-btn"
                  >
                    {intl.formatMessage({ id: "finish" })}
                  </button>
                </div>
              </div>
            </footer>
          </div>
        ) : isShowThakyouBlock === true ? (
          <div>
            <section className="w-full py-12 bg-white">
              <div
                className="max-w-4xl px-4 mx-auto sm:px-6 lg:px-0"
                align="center"
              >
                {/* <h1 className="max-w-2xl mx-auto text-2xl font-semibold text-center sm:text-3xl lg:text-4xl client-servey-question-font-size">
                                     Would you like to be contacted about your feedback? If so, please leave your contact information below
                                    </h1> */}
                <div className="max-w-2xl px-4 mx-auto sm:px-6 lg:px-0">
                  <svg
                    className="w-32 h-32 mx-auto text-rose-600"
                    viewBox="0 0 128 128"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M63.9998 10.6667C34.5447 10.6667 10.6665 34.5448 10.6665 64C10.6665 93.4552 34.5447 117.333 63.9998 117.333C93.455 117.333 117.333 93.4552 117.333 64C117.333 49.8551 111.714 36.2896 101.712 26.2876C91.7103 16.2857 78.1447 10.6667 63.9998 10.6667ZM87.1998 51.8933L57.2265 81.8667C56.7426 82.3823 56.067 82.6748 55.3598 82.6748C54.6527 82.6748 53.9771 82.3823 53.4932 81.8667L40.7998 69.3333C40.295 68.8326 40.011 68.151 40.011 67.44C40.011 66.729 40.295 66.0474 40.7998 65.5467L43.6265 62.72C44.1104 62.2044 44.786 61.9119 45.4932 61.9119C46.2003 61.9119 46.8759 62.2044 47.3598 62.72L55.3598 70.6667L80.6398 45.3867C81.6768 44.3703 83.3363 44.3703 84.3732 45.3867L87.1998 48.2133C88.1819 49.2435 88.1819 50.8632 87.1998 51.8933Z" />
                  </svg>
                  <h1 className="mt-6 text-2xl font-semibold text-center sm:text-3xl lg:text-4xl client-servey-question-font-size">
                    {intl.formatMessage({
                      id: "thank-you-for-taking-time-to-complete-the-survey",
                    })}
                  </h1>
                  <div className="mt-6 text-center">
                    <Link
                      onClick={(e) => window.location.reload()}
                      className="btn btn-primary client-survey-btn"
                      style={{
                        width: "159.56px",
                        height: "38px",
                        fontSize: ".875rem",
                        textTransform: "none",
                      }}
                    >
                      {intl.formatMessage({ id: "return-to-website" })}
                    </Link>
                  </div>
                </div>
              </div>
            </section>
          </div>
        ) : (
          ""
        )}

        {/* main body */}
      </div>
    </React.Fragment>
  );
}
